import { useState, useEffect, useRef } from "react";

// ─── CONSTANTS ────────────────────────────────────────────────
const WEDDING_DATE = new Date("2027-07-17");
const COUPLE = { bride: "Tatiana", groom: "Matheus" };

const EVENT_GROUPS = ["Lamaran", "Pernikahan", "Resepsi"];
// Default categories — hanya dipakai sebagai seed pertama kali.
// Setelah itu user bisa tambah/hapus kategori sendiri dari UI (tersimpan di localStorage).
const DEFAULT_CATEGORIES = {
  Lamaran: ["Venue Lamaran","Dekor Lamaran","Baju Lamaran","MUA & Hairdo Tingling","Kalung Tingling","Dokumentasi Tingling"],
  Pernikahan: ["Bunga Holy Matrimony","MUA Bride","MUA Groom","Attire Bride","Attire Groom","Attire Keluarga","Makeup Keluarga"],
  Resepsi: ["Venue Resepsi","Catering","Dekor Resepsi","Dokumentasi Resepsi","Prewedding","MC","Hiburan","Photobooth","Usher Guest","WO","Attire Bride","Attire Groom","Makeup Keluarga","Mobil"],
};
// Merge: pastikan kategori baru di DEFAULT_CATEGORIES ikut masuk ke data yang sudah tersimpan
function mergeDefaultCategories(saved) {
  const merged = { ...saved };
  EVENT_GROUPS.forEach(eg => {
    const defaults = DEFAULT_CATEGORIES[eg] || [];
    const existing = saved[eg] || [];
    const newOnes = defaults.filter(d => !existing.includes(d));
    merged[eg] = [...existing, ...newOnes];
  });
  return merged;
}
const STATUS_OPTIONS = ["Belum Contact","Sudah Contact","Negosiasi","Confirmed","Cancel"];
const STATUS_STYLE = {
  "Belum Contact": { bg:"#f3f0fa", color:"#7c6fbf" },
  "Sudah Contact": { bg:"#fde8f0", color:"#b5607a" },
  "Negosiasi":     { bg:"#fef3e2", color:"#a06820" },
  "Confirmed":     { bg:"#e5f4ec", color:"#2d7a50" },
  "Cancel":        { bg:"#fee8e8", color:"#a03030" },
};
const CHECKLIST_DEFAULT = [
  {id:1,cat:"12+ bulan",done:false,text:"Tetapkan tanggal & venue resepsi",deadline:""},
  {id:2,cat:"12+ bulan",done:false,text:"Buat anggaran kasar keseluruhan",deadline:""},
  {id:3,cat:"12+ bulan",done:false,text:"Tentukan konsep / tema pernikahan",deadline:""},
  {id:4,cat:"12+ bulan",done:false,text:"Buat daftar tamu awal",deadline:""},
  {id:5,cat:"9–12 bulan",done:false,text:"Booking venue lamaran",deadline:""},
  {id:6,cat:"9–12 bulan",done:false,text:"Booking fotografer & videografer",deadline:""},
  {id:7,cat:"9–12 bulan",done:false,text:"Booking WO / planner",deadline:""},
  {id:8,cat:"9–12 bulan",done:false,text:"Booking catering",deadline:""},
  {id:9,cat:"6–9 bulan",done:false,text:"Fitting baju pengantin pertama",deadline:""},
  {id:10,cat:"6–9 bulan",done:false,text:"Booking makeup artist",deadline:""},
  {id:11,cat:"6–9 bulan",done:false,text:"Booking dekorasi",deadline:""},
  {id:12,cat:"6–9 bulan",done:false,text:"Booking band / MC / hiburan",deadline:""},
  {id:13,cat:"3–6 bulan",done:false,text:"Desain & cetak undangan",deadline:""},
  {id:14,cat:"3–6 bulan",done:false,text:"Kirim undangan gelombang pertama",deadline:""},
  {id:15,cat:"3–6 bulan",done:false,text:"Prewedding shoot",deadline:""},
  {id:16,cat:"3–6 bulan",done:false,text:"Fitting baju pengantin final",deadline:""},
  {id:17,cat:"1–3 bulan",done:false,text:"Konfirmasi semua vendor",deadline:""},
  {id:18,cat:"1–3 bulan",done:false,text:"Selesaikan urusan dokumen & KUA",deadline:""},
  {id:19,cat:"1–3 bulan",done:false,text:"Kirim undangan gelombang kedua",deadline:""},
  {id:20,cat:"1–3 bulan",done:false,text:"Final meeting dengan WO",deadline:""},
  {id:21,cat:"< 1 bulan",done:false,text:"Gladi resik / rehearsal",deadline:""},
  {id:22,cat:"< 1 bulan",done:false,text:"Konfirmasi jumlah tamu final ke catering",deadline:""},
  {id:23,cat:"< 1 bulan",done:false,text:"Persiapkan amplop & souvenir",deadline:""},
  {id:24,cat:"< 1 bulan",done:false,text:"Istirahat & self-care sebelum hari H",deadline:""},
];
const TIMELINE_DEFAULT = [
  {id:1,time:"06.00",activity:"Bangun & sarapan ringan",pic:"Semua"},
  {id:2,time:"07.00",activity:"Makeup & hair bride dimulai",pic:"Bride"},
  {id:3,time:"08.00",activity:"Persiapan groom & keluarga",pic:"Groom"},
  {id:4,time:"10.00",activity:"Akad nikah",pic:"Semua"},
  {id:5,time:"11.30",activity:"Sesi foto keluarga",pic:"Fotografer"},
  {id:6,time:"12.00",activity:"Istirahat & makan siang pengantin",pic:"Bride & Groom"},
  {id:7,time:"13.00",activity:"Pintu resepsi dibuka",pic:"WO"},
  {id:8,time:"13.30",activity:"Pengantin masuk ke resepsi",pic:"Semua"},
  {id:9,time:"15.30",activity:"Sesi foto dengan tamu selesai",pic:"Fotografer"},
  {id:10,time:"16.00",activity:"Acara resepsi selesai",pic:"WO"},
];
const BUDGET_CATS = ["Venue","Catering","Dekorasi","Fotografer & Videografer","MUA & Attire","WO / Planner","Hiburan & MC","Undangan & Souvenir","Transportasi","Lain-lain"];
const SEGMEN_OPTIONS = ["Pembukaan","Prosesi Masuk","Akad","Foto Sesi","Makan","Hiburan","Penutup","Latar Belakang","Lainnya"];
const KELOMPOK = ["Keluarga","Teman Dekat","Rekan Kerja","Kenalan","Lainnya"];
const RSVP_STYLE = {
  "Hadir":         {bg:"#e5f4ec",color:"#2d7a50"},
  "Tidak Hadir":   {bg:"#fee8e8",color:"#a03030"},
  "Belum Konfirm": {bg:"#f3f0fa",color:"#7c6fbf"},
};

// ─── HELPERS ──────────────────────────────────────────────────
const fmtRp = v => (v||0).toLocaleString("id-ID");
const parseRp = v => parseInt(String(v).replace(/[^\d]/g,""),10)||0;
const daysUntil = d => Math.ceil((d - new Date().setHours(0,0,0,0)) / 86400000);
const loadS = (k,fb) => { try { const v=localStorage.getItem(k); return v?JSON.parse(v):fb; } catch { return fb; } };

// ─── TOKENS ───────────────────────────────────────────────────
const C = {
  pink:"#b5607a", pinkLight:"#fde8f0", pinkDark:"#8b3a56",
  lav:"#7c6fbf", lavLight:"#f0ecfa", lavDark:"#5f54b0",
  green:"#2d7a50", greenLight:"#e5f4ec",
  amber:"#a06820", amberLight:"#fef3e2",
  text:"#3d2030", textMid:"#7a5060", textMuted:"#a07090",
  border:"#f0d8e4", bg:"#fffbfd", white:"#ffffff",
};
const inp = {width:"100%",padding:"8px 10px",borderRadius:8,fontSize:13,border:`0.5px solid ${C.border}`,background:C.white,color:C.text,outline:"none",boxSizing:"border-box",fontFamily:"inherit"};
const btnP = {background:C.pink,color:"#fff",border:"none",borderRadius:8,padding:"8px 18px",fontSize:13,fontWeight:500,cursor:"pointer",fontFamily:"inherit"};
const btnO = {background:"transparent",color:C.pink,border:`0.5px solid ${C.border}`,borderRadius:8,padding:"8px 14px",fontSize:13,cursor:"pointer",fontFamily:"inherit"};
const cardS = {background:C.white,border:`0.5px solid ${C.border}`,borderRadius:12,padding:"16px 18px"};

// ─── MICRO COMPONENTS ─────────────────────────────────────────
const Lbl = ({children}) => <div style={{fontSize:11,color:C.textMuted,marginBottom:4,fontWeight:500,letterSpacing:"0.03em"}}>{children}</div>;
const Pill = ({children,color,bg}) => <span style={{fontSize:10,padding:"2px 10px",borderRadius:20,background:bg||C.pinkLight,color:color||C.pink,fontWeight:500,whiteSpace:"nowrap"}}>{children}</span>;
const Divider = ({label}) => (
  <div style={{display:"flex",alignItems:"center",gap:10,margin:"20px 0 12px"}}>
    <div style={{flex:1,height:"0.5px",background:C.border}}/>
    <span style={{fontSize:10,fontWeight:700,letterSpacing:"0.08em",color:C.pink,textTransform:"uppercase"}}>{label}</span>
    <div style={{flex:1,height:"0.5px",background:C.border}}/>
  </div>
);
const Empty = ({icon,msg}) => (
  <div style={{textAlign:"center",padding:"60px 0",color:C.textMuted}}>
    <div style={{fontSize:36,marginBottom:10}}>{icon}</div>
    <div style={{fontSize:14}}>{msg}</div>
  </div>
);
function Stars({value,onChange}) {
  const [hov,setHov]=useState(0);
  return <div style={{display:"flex",gap:2}}>{[1,2,3,4,5].map(s=>(
    <span key={s} onMouseEnter={()=>onChange&&setHov(s)} onMouseLeave={()=>onChange&&setHov(0)}
      onClick={()=>onChange&&onChange(s===value?0:s)}
      style={{fontSize:15,cursor:onChange?"pointer":"default",color:s<=(hov||value)?"#e8a045":"#e0d5e8"}}>★</span>
  ))}</div>;
}
function StatCard({label,value,sub,accent}) {
  return <div style={{...cardS,padding:"14px 16px"}}>
    <div style={{fontSize:10,color:C.textMuted,textTransform:"uppercase",letterSpacing:"0.05em",marginBottom:4}}>{label}</div>
    <div style={{fontSize:22,fontWeight:700,color:accent||C.pink}}>{value}</div>
    {sub&&<div style={{fontSize:11,color:C.textMuted,marginTop:2}}>{sub}</div>}
  </div>;
}
function ProgBar({pct,color}) {
  return <div style={{background:C.pinkLight,borderRadius:4,height:5,overflow:"hidden",marginTop:6}}>
    <div style={{width:`${Math.min(pct,100)}%`,height:"100%",background:color||C.pink,borderRadius:4,transition:"width 0.4s"}}/>
  </div>;
}

// ─── VENDOR MODAL ─────────────────────────────────────────────
const EMPTY_V = {id:null,event:"Lamaran",kategori:"",nama:"",harga:"",pax:"",hargaPerPax:"",linkIG:"",linkWA:"",linkPricelist:"",rating:0,status:"Belum Contact",catatan:"",kelebihan:"",kekurangan:"",portfolio:[],brief:[]};

// Helper upload foto untuk modal
function PhotoGrid({photos,onAdd,onDel,onStar,onCaption,emptyMsg,starLabel}) {
  return (
    <div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(140px,1fr))",gap:10,marginBottom:10}}>
        {photos.map(p=>(
          <div key={p.id} style={{borderRadius:10,overflow:"hidden",border:`2px solid ${p.starred?"#e8a045":C.border}`,background:"#fdf8fc",position:"relative"}}>
            <div style={{aspectRatio:"4/3",overflow:"hidden",background:"#f0e8f0"}}>
              <img src={p.src} alt={p.caption||""} style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>
            </div>
            <div style={{padding:"6px 8px"}}>
              <input value={p.caption||""} onChange={e=>onCaption(p.id,e.target.value)} placeholder="Keterangan..." style={{...inp,fontSize:10,padding:"3px 6px",marginBottom:4}}/>
              <div style={{display:"flex",gap:4}}>
                <button onClick={()=>onStar(p.id)} style={{flex:1,background:p.starred?"#fef3e2":"none",border:`0.5px solid ${p.starred?"#e8a045":C.border}`,borderRadius:5,padding:"2px 0",fontSize:10,cursor:"pointer",color:p.starred?"#a06820":C.textMuted}}>
                  {p.starred?`⭐ ${starLabel}`:`☆ ${starLabel}`}
                </button>
                <button onClick={()=>onDel(p.id)} style={{background:"none",border:`0.5px solid ${C.border}`,borderRadius:5,padding:"2px 6px",fontSize:11,color:C.textMuted,cursor:"pointer"}}>×</button>
              </div>
            </div>
          </div>
        ))}
        <label style={{borderRadius:10,border:`1.5px dashed ${C.border}`,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",cursor:"pointer",color:C.textMuted,gap:6,minHeight:120,aspectRatio:"4/3",background:"#fdf8fc"}}>
          <span style={{fontSize:22}}>+</span>
          <span style={{fontSize:10}}>Upload</span>
          <input type="file" accept="image/*" multiple onChange={onAdd} style={{display:"none"}}/>
        </label>
      </div>
      {photos.length===0&&<div style={{fontSize:11,color:C.textMuted,fontStyle:"italic"}}>{emptyMsg}</div>}
    </div>
  );
}

function VendorModal({vendor,onClose,onSave,categoryOptions}) {
  const [f,setF]=useState({...EMPTY_V,...vendor,portfolio:vendor.portfolio||[],brief:vendor.brief||[]});
  const [tab,setTab]=useState("info");
  const set=(k,v)=>setF(p=>({...p,[k]:v}));
  const cats=(categoryOptions||DEFAULT_CATEGORIES)[f.event]||[];

  const addPhotos=(field,e)=>{
    const files=Array.from(e.target.files);
    files.forEach(file=>{
      const reader=new FileReader();
      reader.onload=ev=>{
        setF(p=>({...p,[field]:[...p[field],{id:Date.now()+Math.random(),src:ev.target.result,caption:"",starred:false}]}));
      };
      reader.readAsDataURL(file);
    });
    e.target.value="";
  };
  const delPhoto=(field,id)=>setF(p=>({...p,[field]:p[field].filter(x=>x.id!==id)}));
  const starPhoto=(field,id)=>setF(p=>({...p,[field]:p[field].map(x=>x.id===id?{...x,starred:!x.starred}:x)}));
  const captionPhoto=(field,id,v)=>setF(p=>({...p,[field]:p[field].map(x=>x.id===id?{...x,caption:v}:x)}));

  const tabStyle=(t)=>({background:tab===t?C.white:"transparent",border:`0.5px solid ${tab===t?C.border:"transparent"}`,borderRadius:"8px 8px 0 0",padding:"7px 16px",fontSize:12,fontWeight:tab===t?600:400,color:tab===t?C.pinkDark:C.textMuted,cursor:"pointer",fontFamily:"inherit"});

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(80,40,60,0.2)",zIndex:200,display:"flex",alignItems:"center",justifyContent:"center"}} onClick={onClose}>
      <div style={{background:C.white,borderRadius:16,width:620,maxHeight:"92vh",display:"flex",flexDirection:"column",border:`0.5px solid ${C.border}`}} onClick={e=>e.stopPropagation()}>
        {/* Header */}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"20px 24px 0"}}>
          <span style={{fontSize:15,fontWeight:600,color:C.pinkDark}}>{f.id?"Edit vendor":"Tambah vendor"}{f.nama?` · ${f.nama}`:""}</span>
          <button onClick={onClose} style={{background:"none",border:"none",fontSize:22,color:C.textMuted,cursor:"pointer",lineHeight:1}}>×</button>
        </div>
        {/* Tabs */}
        <div style={{display:"flex",gap:4,padding:"12px 24px 0",borderBottom:`0.5px solid ${C.border}`,background:C.pinkLight}}>
          <button style={tabStyle("info")} onClick={()=>setTab("info")}>📋 Info</button>
          <button style={tabStyle("portfolio")} onClick={()=>setTab("portfolio")}>
            📁 Portofolio {f.portfolio.length>0&&<span style={{fontSize:10,background:C.pinkLight,color:C.pink,padding:"1px 5px",borderRadius:10,marginLeft:4}}>{f.portfolio.length}</span>}
          </button>
          <button style={tabStyle("brief")} onClick={()=>setTab("brief")}>
            🎯 Referensi {f.brief.length>0&&<span style={{fontSize:10,background:"#fef3e2",color:"#a06820",padding:"1px 5px",borderRadius:10,marginLeft:4}}>{f.brief.length}</span>}
          </button>
        </div>
        {/* Body */}
        <div style={{overflowY:"auto",padding:"20px 24px",flex:1}}>
          {tab==="info"&&(
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"12px 16px"}}>
              <div style={{gridColumn:"1/-1"}}><Lbl>Event</Lbl>
                <select value={f.event} onChange={e=>{set("event",e.target.value);set("kategori","");}} style={inp}>
                  {EVENT_GROUPS.map(g=><option key={g}>{g}</option>)}
                </select>
              </div>
              <div style={{gridColumn:"1/-1"}}><Lbl>Kategori</Lbl>
                <select value={f.kategori} onChange={e=>set("kategori",e.target.value)} style={inp}>
                  <option value="">— Pilih kategori —</option>
                  {cats.map(c=><option key={c}>{c}</option>)}
                </select>
              </div>
              <div style={{gridColumn:"1/-1"}}><Lbl>Nama vendor *</Lbl>
                <input value={f.nama} onChange={e=>set("nama",e.target.value)} placeholder="contoh: Richie Garden" style={inp}/>
              </div>
              <div><Lbl>Harga paket (Rp)</Lbl>
                <input value={f.harga?fmtRp(f.harga):""} onChange={e=>set("harga",parseRp(e.target.value))} placeholder="0" style={inp}/>
              </div>
              <div><Lbl>Pax / unit</Lbl>
                <input value={f.pax} onChange={e=>set("pax",e.target.value.replace(/\D/g,""))} placeholder="120" style={inp}/>
              </div>
              <div><Lbl>Harga per pax (Rp)</Lbl>
                <input value={f.hargaPerPax?fmtRp(f.hargaPerPax):""} onChange={e=>set("hargaPerPax",parseRp(e.target.value))} placeholder="opsional" style={inp}/>
              </div>
              <div><Lbl>Status</Lbl>
                <select value={f.status} onChange={e=>set("status",e.target.value)} style={inp}>
                  {STATUS_OPTIONS.map(s=><option key={s}>{s}</option>)}
                </select>
              </div>
              <div><Lbl>Link Instagram</Lbl>
                <input value={f.linkIG} onChange={e=>set("linkIG",e.target.value)} placeholder="instagram.com/..." style={inp}/>
              </div>
              <div><Lbl>Link WhatsApp</Lbl>
                <input value={f.linkWA} onChange={e=>set("linkWA",e.target.value)} placeholder="wa.me/628..." style={inp}/>
              </div>
              <div style={{gridColumn:"1/-1"}}><Lbl>Link Pricelist</Lbl>
                <input value={f.linkPricelist} onChange={e=>set("linkPricelist",e.target.value)} placeholder="drive.google.com/... atau link lain" style={inp}/>
              </div>
              <div style={{gridColumn:"1/-1"}}><Lbl>Rating kesan</Lbl><Stars value={f.rating} onChange={v=>set("rating",v)}/></div>
              <div style={{gridColumn:"1/-1"}}><Lbl>Catatan</Lbl>
                <textarea value={f.catatan} onChange={e=>set("catatan",e.target.value)} placeholder="Include AC, parkir, min pax..." rows={3} style={{...inp,resize:"vertical"}}/>
              </div>
              <div style={{gridColumn:"1/-1"}}><Lbl>✅ Kelebihan</Lbl>
                <textarea value={f.kelebihan||""} onChange={e=>set("kelebihan",e.target.value)} placeholder={"Pisah tiap poin dengan baris baru, contoh:\n- Harga terjangkau\n- Responsif dan fast response\n- Portofolio sesuai style"} rows={3} style={{...inp,resize:"vertical"}}/>
              </div>
              <div style={{gridColumn:"1/-1"}}><Lbl>❌ Kekurangan</Lbl>
                <textarea value={f.kekurangan||""} onChange={e=>set("kekurangan",e.target.value)} placeholder={"Pisah tiap poin dengan baris baru, contoh:\n- DP besar 50%\n- Lokasi jauh\n- Belum ada sample untuk hari H"} rows={3} style={{...inp,resize:"vertical"}}/>
              </div>
            </div>
          )}
          {tab==="portfolio"&&(
            <div>
              <div style={{fontSize:12,color:C.textMuted,marginBottom:14}}>📁 Foto hasil kerja vendor ini — upload dari IG atau website mereka. Bintangi foto terbaik untuk ditampilkan di Vision Board.</div>
              <PhotoGrid
                photos={f.portfolio}
                onAdd={e=>addPhotos("portfolio",e)}
                onDel={id=>delPhoto("portfolio",id)}
                onStar={id=>starPhoto("portfolio",id)}
                onCaption={(id,v)=>captionPhoto("portfolio",id,v)}
                emptyMsg="Belum ada foto portofolio. Upload dari IG atau website vendor."
                starLabel="Terbaik"
              />
            </div>
          )}
          {tab==="brief"&&(
            <div>
              <div style={{fontSize:12,color:C.textMuted,marginBottom:14}}>🎯 Foto referensi yang ingin kamu capai bersama vendor ini — dari Pinterest, IG, atau inspirasi lain. Ini yang akan kamu tunjukkan ke mereka. Bintangi yang jadi pilihan final.</div>
              <PhotoGrid
                photos={f.brief}
                onAdd={e=>addPhotos("brief",e)}
                onDel={id=>delPhoto("brief",id)}
                onStar={id=>starPhoto("brief",id)}
                onCaption={(id,v)=>captionPhoto("brief",id,v)}
                emptyMsg="Belum ada referensi. Upload foto inspirasi dari Pinterest atau IG."
                starLabel="Final"
              />
            </div>
          )}
        </div>
        {/* Footer */}
        <div style={{display:"flex",justifyContent:"flex-end",gap:10,padding:"14px 24px",borderTop:`0.5px solid ${C.border}`}}>
          <button onClick={onClose} style={btnO}>Batal</button>
          <button onClick={()=>{if(!f.nama.trim())return alert("Nama vendor wajib diisi.");onSave(f);}} style={btnP}>Simpan</button>
        </div>
      </div>
    </div>
  );
}

// ─── PAGE: DASHBOARD ──────────────────────────────────────────
function Dashboard({vendors,checklist,guests,budget,timeline}) {
  const days=daysUntil(WEDDING_DATE);
  const doneTasks=checklist.filter(c=>c.done).length;
  const confirmedV=vendors.filter(v=>v.status==="Confirmed").length;
  const confirmedG=guests.filter(g=>g.rsvp==="Hadir").reduce((s,g)=>s+(Number(g.jumlah)||1),0);
  const totalGuestCount=guests.reduce((s,g)=>s+(Number(g.jumlah)||1),0);
  const totalBudget=budget.total||0;
  const usedBudget=(budget.items||[]).reduce((s,i)=>s+(i.actual||0),0);
  const budgetPct=totalBudget>0?Math.round(usedBudget/totalBudget*100):0;
  const urgentTasks=checklist.filter(c=>!c.done).slice(0,4);
  return (
    <div>
      <div style={{background:"linear-gradient(135deg,#fde8f0 0%,#f0ecfa 100%)",border:`0.5px solid ${C.border}`,borderRadius:16,padding:"28px 28px 24px",marginBottom:22,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <div>
          <div style={{fontSize:12,color:C.textMuted,marginBottom:6}}>{COUPLE.bride} & {COUPLE.groom} · 17 Juli 2027</div>
          <div style={{fontSize:52,fontWeight:800,color:C.pinkDark,lineHeight:1}}>{days}</div>
          <div style={{fontSize:16,color:C.pink,marginTop:4}}>hari lagi</div>
          <div style={{fontSize:12,color:C.textMuted,marginTop:8}}>{Math.floor(days/30)} bulan {days%30} hari</div>
        </div>
        <div style={{textAlign:"right"}}>
          <div style={{fontSize:64,lineHeight:1,marginBottom:8}}>💍</div>
          <div style={{fontSize:12,color:C.textMuted}}>Sebentar lagi ya 🌸</div>
        </div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:22}}>
        <StatCard label="Checklist selesai" value={`${doneTasks}/${checklist.length}`} sub={`${Math.round(doneTasks/Math.max(checklist.length,1)*100)}% selesai`} accent={C.pink}/>
        <StatCard label="Vendor confirmed" value={`${confirmedV}/${vendors.length}`} sub={vendors.length===0?"Belum ada vendor":""} accent={C.lav}/>
        <StatCard label="Budget terpakai" value={`${budgetPct}%`} sub={totalBudget>0?`Rp ${fmtRp(usedBudget)} / ${fmtRp(totalBudget)}`:"Belum diisi"} accent={C.amber}/>
        <StatCard label="Tamu konfirmasi" value={`${confirmedG}/${totalGuestCount}`} sub={guests.length===0?"Belum ada tamu":`${guests.length} undangan`} accent={C.green}/>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
        <div style={cardS}>
          <div style={{fontSize:13,fontWeight:600,color:C.pinkDark,marginBottom:12}}>Yang belum selesai</div>
          {urgentTasks.length===0?<div style={{fontSize:13,color:C.textMuted,padding:"12px 0"}}>Semua checklist selesai! 🎉</div>
            :urgentTasks.map(t=>(
              <div key={t.id} style={{display:"flex",gap:10,alignItems:"flex-start",padding:"6px 0",borderBottom:`0.5px solid ${C.border}`}}>
                <div style={{width:14,height:14,borderRadius:"50%",border:`1.5px solid ${C.border}`,marginTop:1,flexShrink:0}}/>
                <div><div style={{fontSize:13,color:C.text}}>{t.text}</div><div style={{fontSize:11,color:C.textMuted}}>{t.cat}</div></div>
              </div>
            ))}
          {checklist.filter(c=>!c.done).length>4&&<div style={{fontSize:11,color:C.textMuted,marginTop:8}}>+{checklist.filter(c=>!c.done).length-4} item lainnya</div>}
        </div>
        <div style={cardS}>
          <div style={{fontSize:13,fontWeight:600,color:C.pinkDark,marginBottom:12}}>Status vendor terbaru</div>
          {vendors.length===0?<div style={{fontSize:13,color:C.textMuted,padding:"12px 0"}}>Belum ada vendor.</div>
            :vendors.slice(0,5).map(v=>{const st=STATUS_STYLE[v.status]||STATUS_STYLE["Belum Contact"];return(
              <div key={v.id} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"6px 0",borderBottom:`0.5px solid ${C.border}`}}>
                <div><div style={{fontSize:13,color:C.text}}>{v.nama}</div><div style={{fontSize:11,color:C.textMuted}}>{v.kategori}</div></div>
                <Pill color={st.color} bg={st.bg}>{v.status}</Pill>
              </div>
            );})}
          {vendors.length>5&&<div style={{fontSize:11,color:C.textMuted,marginTop:8}}>+{vendors.length-5} vendor lainnya</div>}
        </div>
      </div>
    </div>
  );
}

// ─── NOTE RENDERER ────────────────────────────────────────────
function renderNote(text, onToggleCheck) {
  if (!text) return null;
  const lines = text.split("\n");
  return lines.map((line, i) => {
    // Checkbox ☐ / ☑
    const cbUnchecked = line.match(/^(☐)\s(.*)$/);
    const cbChecked   = line.match(/^(☑)\s(.*)$/);
    if (cbUnchecked || cbChecked) {
      const checked = !!cbChecked;
      const label   = checked ? cbChecked[2] : cbUnchecked[2];
      return (
        <div key={i} style={{display:"flex",alignItems:"flex-start",gap:8,marginBottom:3}}>
          <span
            onClick={()=>onToggleCheck(i,checked)}
            style={{fontSize:15,cursor:"pointer",lineHeight:1.5,flexShrink:0,userSelect:"none",color:checked?C.green:C.textMuted}}
          >{checked?"☑":"☐"}</span>
          <span style={{fontSize:13,color:checked?C.textMuted:C.text,textDecoration:checked?"line-through":"none",lineHeight:1.5}}>{renderInline(label)}</span>
        </div>
      );
    }
    // Heading # / ##
    if (/^##\s/.test(line)) return <div key={i} style={{fontSize:12,fontWeight:700,color:C.lav,textTransform:"uppercase",letterSpacing:"0.06em",marginTop:10,marginBottom:4}}>{line.replace(/^##\s/,"")}</div>;
    if (/^#\s/.test(line))  return <div key={i} style={{fontSize:14,fontWeight:700,color:C.pinkDark,marginTop:12,marginBottom:4}}>{line.replace(/^#\s/,"")}</div>;
    // Separator ---
    if (/^---+$/.test(line.trim())) return <div key={i} style={{height:"0.5px",background:C.border,margin:"10px 0"}}/>;
    // Bullet * / -
    if (/^[*\-]\s/.test(line)) return (
      <div key={i} style={{display:"flex",alignItems:"flex-start",gap:8,marginBottom:3}}>
        <span style={{color:C.pink,fontSize:14,lineHeight:1.4,flexShrink:0}}>•</span>
        <span style={{fontSize:13,color:C.text,lineHeight:1.5}}>{renderInline(line.replace(/^[*\-]\s/,""))}</span>
      </div>
    );
    // Empty line → spacer
    if (!line.trim()) return <div key={i} style={{height:6}}/>;
    // Normal paragraph
    return <div key={i} style={{fontSize:13,color:C.text,lineHeight:1.6,marginBottom:2}}>{renderInline(line)}</div>;
  });
}
function renderInline(text) {
  // **bold**
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p,i) =>
    /^\*\*[^*]+\*\*$/.test(p)
      ? <strong key={i} style={{color:C.pinkDark}}>{p.slice(2,-2)}</strong>
      : p
  );
}

// ─── NOTE EDITOR ──────────────────────────────────────────────
function NoteEditor({value, onChange}) {
  const taRef = useRef();
  const [preview, setPreview] = useState(false);

  const insert = (before, after="", placeholder="teks") => {
    const ta = taRef.current;
    if (!ta) return;
    const start = ta.selectionStart, end = ta.selectionEnd;
    const sel = value.slice(start, end) || placeholder;
    const newVal = value.slice(0,start) + before + sel + after + value.slice(end);
    onChange(newVal);
    setTimeout(()=>{ ta.focus(); ta.setSelectionRange(start+before.length, start+before.length+sel.length); },0);
  };
  const insertLine = (prefix) => {
    const ta = taRef.current;
    if (!ta) return;
    const start = ta.selectionStart;
    const before = value.slice(0,start);
    const lineStart = before.lastIndexOf("\n")+1;
    const newVal = value.slice(0,lineStart) + prefix + value.slice(lineStart);
    onChange(newVal);
    setTimeout(()=>{ ta.focus(); ta.setSelectionRange(start+prefix.length, start+prefix.length); },0);
  };

  const onToggleCheck = (lineIdx, wasChecked) => {
    const lines = value.split("\n");
    lines[lineIdx] = wasChecked
      ? lines[lineIdx].replace(/^☑\s/, "☐ ")
      : lines[lineIdx].replace(/^☐\s/, "☑ ");
    onChange(lines.join("\n"));
  };

  const toolBtn = (label, title, action) => (
    <button
      title={title}
      onMouseDown={e=>{e.preventDefault();action();}}
      style={{background:"none",border:`0.5px solid ${C.border}`,borderRadius:5,padding:"2px 8px",fontSize:12,color:C.textMid,cursor:"pointer",fontFamily:"inherit",lineHeight:1.5}}
    >{label}</button>
  );

  return (
    <div>
      {/* Toolbar */}
      <div style={{display:"flex",alignItems:"center",gap:5,marginBottom:7,flexWrap:"wrap"}}>
        {!preview && <>
          {toolBtn("☐","Kotak checklist",()=>insertLine("☐ "))}
          {toolBtn("•","Bullet",()=>insertLine("• "))}
          {toolBtn("* bullet","Bullet (markdown)",()=>insertLine("- "))}
          {toolBtn("# H1","Heading besar",()=>insertLine("# "))}
          {toolBtn("## H2","Heading kecil",()=>insertLine("## "))}
          {toolBtn("**B**","Bold",()=>insert("**","**","teks bold"))}
          {toolBtn("---","Garis pemisah",()=>{
            const ta=taRef.current; if(!ta)return;
            const s=ta.selectionStart;
            const prefix=value[s-1]==="\n"||s===0?"":"\n";
            onChange(value.slice(0,s)+prefix+"---\n"+value.slice(s));
            const jump=s+prefix.length+4;
            setTimeout(()=>{ta.focus();ta.setSelectionRange(jump,jump);},0);
          })}
        </>}
        <div style={{flex:1}}/>
        <button
          onMouseDown={e=>e.preventDefault()}
          onClick={()=>setPreview(p=>!p)}
          style={{background:preview?C.pinkLight:"none",border:`0.5px solid ${C.border}`,borderRadius:5,padding:"2px 10px",fontSize:11,color:preview?C.pink:C.textMuted,cursor:"pointer",fontWeight:preview?600:400}}
        >{preview?"✏️ Edit":"👁 Preview"}</button>
      </div>

      {/* Edit mode */}
      {!preview && (
        <textarea
          ref={taRef}
          value={value}
          onChange={e=>onChange(e.target.value)}
          placeholder={"Tulis catatan, daftar perlengkapan, atau reminder...\n\nContoh:\n☐ Hubungi venue minggu ini\n☐ Bawa KTP dan buku nikah\n- Konfirmasi jumlah tamu ke catering\n**Penting:** cek DP sebelum tanggal 15"}
          rows={6}
          style={{...inp,resize:"vertical",fontSize:13,lineHeight:1.7,fontFamily:"'Menlo','Consolas',monospace",background:C.white,minHeight:130}}
        />
      )}

      {/* Preview mode */}
      {preview && (
        <div style={{...inp,minHeight:130,padding:"12px 14px",lineHeight:1.7,background:C.white,cursor:"text",overflowY:"auto"}}>
          {value.trim()
            ? renderNote(value, onToggleCheck)
            : <span style={{color:C.textMuted,fontSize:13}}>Belum ada catatan.</span>
          }
        </div>
      )}

      <div style={{fontSize:10,color:C.textMuted,marginTop:6}}>
        {preview
          ? "Mode preview — klik ☐ untuk centang langsung"
          : "Ketik bebas atau gunakan toolbar. ☐ = kotak, * atau - = bullet, **teks** = bold, # = heading, --- = garis"}
      </div>
    </div>
  );
}

// ─── PAGE: CHECKLIST ──────────────────────────────────────────
function ChecklistPage({checklist,setChecklist}) {
  const [newText,setNewText]=useState("");
  const [newCat,setNewCat]=useState("< 1 bulan");
  const [newDeadline,setNewDeadline]=useState("");
  const [expanded,setExpanded]=useState({});
  const ORDER=["12+ bulan","9–12 bulan","6–9 bulan","3–6 bulan","1–3 bulan","< 1 bulan"];
  const done=checklist.filter(c=>c.done).length;
  const toggle=id=>setChecklist(cs=>cs.map(c=>c.id===id?{...c,done:!c.done}:c));
  const del=id=>setChecklist(cs=>cs.filter(c=>c.id!==id));
  const setDeadline=(id,v)=>setChecklist(cs=>cs.map(c=>c.id===id?{...c,deadline:v}:c));
  const setNote=(id,v)=>setChecklist(cs=>cs.map(c=>c.id===id?{...c,note:v}:c));
  const toggleExpand=id=>setExpanded(e=>({...e,[id]:!e[id]}));
  const add=()=>{
    if(!newText.trim())return;
    setChecklist(cs=>[...cs,{id:Date.now(),cat:newCat,done:false,text:newText.trim(),deadline:newDeadline,note:""}]);
    setNewText("");setNewDeadline("");
  };
  const grouped={};
  checklist.forEach(c=>{if(!grouped[c.cat])grouped[c.cat]=[];grouped[c.cat].push(c);});
  const sortedGroups=Object.keys(grouped).sort((a,b)=>{const ai=ORDER.indexOf(a),bi=ORDER.indexOf(b);return(ai===-1?99:ai)-(bi===-1?99:bi);});
  return (
    <div>
      <div style={{...cardS,marginBottom:20}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
          <span style={{fontSize:13,fontWeight:600,color:C.pinkDark}}>Progress keseluruhan</span>
          <span style={{fontSize:20,fontWeight:700,color:C.pink}}>{done}/{checklist.length}</span>
        </div>
        <ProgBar pct={Math.round(done/Math.max(checklist.length,1)*100)}/>
        <div style={{fontSize:11,color:C.textMuted,marginTop:6}}>{Math.round(done/Math.max(checklist.length,1)*100)}% selesai</div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"130px 1fr 160px auto",gap:8,marginBottom:22,alignItems:"end"}}>
        <div><Lbl>Kategori</Lbl><select value={newCat} onChange={e=>setNewCat(e.target.value)} style={inp}>{ORDER.map(o=><option key={o}>{o}</option>)}</select></div>
        <div><Lbl>Item baru</Lbl><input value={newText} onChange={e=>setNewText(e.target.value)} onKeyDown={e=>e.key==="Enter"&&add()} placeholder="Tambah item checklist..." style={inp}/></div>
        <div><Lbl>Deadline</Lbl><input type="date" value={newDeadline} onChange={e=>setNewDeadline(e.target.value)} style={inp}/></div>
        <button onClick={add} style={{...btnP,alignSelf:"end"}}>Tambah</button>
      </div>
      {sortedGroups.map(grp=>{
        const items=grouped[grp];
        const grpDone=items.filter(c=>c.done).length;
        return(
          <div key={grp} style={{marginBottom:20}}>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
              <span style={{fontSize:11,fontWeight:700,color:C.lav,textTransform:"uppercase",letterSpacing:"0.07em"}}>{grp}</span>
              <span style={{fontSize:11,color:C.textMuted}}>{grpDone}/{items.length}</span>
              <div style={{flex:1,height:"0.5px",background:C.border}}/>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:6}}>
              {items.map(item=>{
                const isOpen=!!expanded[item.id];
                const hasNote=!!(item.note&&item.note.trim());
                return(
                  <div key={item.id} style={{...cardS,padding:0,opacity:item.done?0.65:1,overflow:"hidden"}}>
                    {/* Row utama */}
                    <div style={{padding:"10px 14px",display:"flex",alignItems:"center",gap:12}}>
                      {/* Tombol centang */}
                      <div onClick={()=>toggle(item.id)} style={{width:18,height:18,borderRadius:"50%",flexShrink:0,cursor:"pointer",border:item.done?"none":`1.5px solid ${C.border}`,background:item.done?C.pink:"transparent",display:"flex",alignItems:"center",justifyContent:"center"}}>
                        {item.done&&<span style={{color:"white",fontSize:10,fontWeight:700}}>✓</span>}
                      </div>
                      {/* Teks + klik untuk expand */}
                      <div onClick={()=>toggleExpand(item.id)} style={{flex:1,cursor:"pointer",minWidth:0}}>
                        <div style={{display:"flex",alignItems:"center",gap:8}}>
                          <span style={{fontSize:13,color:C.text,textDecoration:item.done?"line-through":"none",fontWeight:500}}>{item.text}</span>
                          {hasNote&&<span style={{fontSize:9,background:C.lavLight,color:C.lav,padding:"1px 7px",borderRadius:10,fontWeight:600,whiteSpace:"nowrap"}}>📝 note</span>}
                        </div>
                        {hasNote&&!isOpen&&(
                          <div style={{fontSize:11,color:C.textMuted,marginTop:3,overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis",maxWidth:420}}>
                            {item.note.split("\n")[0]}
                          </div>
                        )}
                      </div>
                      {/* Deadline */}
                      <input type="date" value={item.deadline||""} onChange={e=>setDeadline(item.id,e.target.value)} onClick={e=>e.stopPropagation()} style={{...inp,width:150,fontSize:11,padding:"4px 8px"}}/>
                      {/* Toggle expand */}
                      <button onClick={()=>toggleExpand(item.id)} style={{background:"none",border:`0.5px solid ${C.border}`,borderRadius:6,padding:"3px 8px",fontSize:12,color:C.textMuted,cursor:"pointer",lineHeight:1,flexShrink:0}}>
                        {isOpen?"▲":"▼"}
                      </button>
                      {/* Hapus */}
                      <button onClick={()=>del(item.id)} style={{background:"none",border:"none",color:C.textMuted,cursor:"pointer",fontSize:16,padding:"0 2px",flexShrink:0}}>×</button>
                    </div>
                    {/* Panel detail / note */}
                    {isOpen&&(
                      <div style={{borderTop:`0.5px solid ${C.border}`,background:"#fdf8fc",padding:"14px 16px"}}>
                        <div style={{fontSize:11,fontWeight:600,color:C.pinkDark,marginBottom:10}}>📝 Catatan &amp; Reminder</div>
                        <NoteEditor value={item.note||""} onChange={v=>setNote(item.id,v)}/>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}

// ─── PAGE: VENDOR LIST ────────────────────────────────────────
function VendorListPage({vendors,setVendors,categoryOptions,setCategoryOptions}) {
  const [modal,setModal]=useState(null);
  const [filterEvent,setFilterEvent]=useState("Semua");
  const [filterStatus,setFilterStatus]=useState("Semua");
  const [search,setSearch]=useState("");
  const [showCatMgr,setShowCatMgr]=useState(false);
  const [catMgrEvent,setCatMgrEvent]=useState("Resepsi");
  const [newCatName,setNewCatName]=useState("");

  const filtered=vendors.filter(v=>{
    if(filterEvent!=="Semua"&&v.event!==filterEvent)return false;
    if(filterStatus!=="Semua"&&v.status!==filterStatus)return false;
    if(search&&!v.nama.toLowerCase().includes(search.toLowerCase())&&!v.kategori.toLowerCase().includes(search.toLowerCase()))return false;
    return true;
  });
  const save=f=>{setVendors(vs=>f.id?vs.map(v=>v.id===f.id?f:v):[...vs,{...f,id:Date.now()}]);setModal(null);};
  const del=id=>{if(window.confirm("Hapus vendor ini?"))setVendors(vs=>vs.filter(v=>v.id!==id));};
  const groups={};
  filtered.forEach(v=>{const e=v.event||"Lainnya",c=v.kategori||"Tanpa kategori";if(!groups[e])groups[e]={};if(!groups[e][c])groups[e][c]=[];groups[e][c].push(v);});

  // Kelola kategori
  const addCat=()=>{
    const name=newCatName.trim();
    if(!name)return;
    const existing=categoryOptions[catMgrEvent]||[];
    if(existing.includes(name))return alert("Kategori sudah ada.");
    setCategoryOptions(prev=>({...prev,[catMgrEvent]:[...existing,name]}));
    setNewCatName("");
  };
  const delCat=(event,cat)=>{
    const usedByVendor=vendors.some(v=>v.event===event&&v.kategori===cat);
    if(usedByVendor&&!window.confirm(`Kategori "${cat}" masih dipakai vendor. Hapus tetap?`))return;
    setCategoryOptions(prev=>({...prev,[event]:(prev[event]||[]).filter(c=>c!==cat)}));
  };
  const moveCat=(event,cat,dir)=>{
    const list=[...(categoryOptions[event]||[])];
    const i=list.indexOf(cat);
    if(i<0)return;
    const j=i+dir;
    if(j<0||j>=list.length)return;
    [list[i],list[j]]=[list[j],list[i]];
    setCategoryOptions(prev=>({...prev,[event]:list}));
  };

  return(
    <div>
      {modal&&<VendorModal vendor={modal} onClose={()=>setModal(null)} onSave={save} categoryOptions={categoryOptions}/>}

      {/* Panel kelola kategori */}
      {showCatMgr&&(
        <div style={{...cardS,marginBottom:20,background:C.lavLight,border:`0.5px solid ${C.lav}22`}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
            <span style={{fontSize:13,fontWeight:600,color:C.lavDark}}>⚙️ Kelola Kategori Vendor</span>
            <button onClick={()=>setShowCatMgr(false)} style={{background:"none",border:"none",fontSize:18,color:C.textMuted,cursor:"pointer"}}>×</button>
          </div>
          <div style={{display:"flex",gap:8,marginBottom:14}}>
            {EVENT_GROUPS.map(eg=>(
              <button key={eg} onClick={()=>setCatMgrEvent(eg)}
                style={{...catMgrEvent===eg?btnP:btnO,padding:"5px 14px",fontSize:12}}>
                {eg}
              </button>
            ))}
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:6,marginBottom:12}}>
            {(categoryOptions[catMgrEvent]||[]).map((cat,i,arr)=>{
              const isUsed=vendors.some(v=>v.event===catMgrEvent&&v.kategori===cat);
              return(
                <div key={cat} style={{display:"flex",alignItems:"center",gap:8,background:C.white,borderRadius:8,padding:"7px 12px",border:`0.5px solid ${C.border}`}}>
                  <span style={{flex:1,fontSize:13,color:C.text}}>{cat}</span>
                  {isUsed&&<Pill bg={C.greenLight} color={C.green}>ada vendor</Pill>}
                  <button onClick={()=>moveCat(catMgrEvent,cat,-1)} disabled={i===0} style={{background:"none",border:"none",color:i===0?C.border:C.textMuted,cursor:i===0?"default":"pointer",fontSize:14,padding:"0 3px"}}>↑</button>
                  <button onClick={()=>moveCat(catMgrEvent,cat,1)} disabled={i===arr.length-1} style={{background:"none",border:"none",color:i===arr.length-1?C.border:C.textMuted,cursor:i===arr.length-1?"default":"pointer",fontSize:14,padding:"0 3px"}}>↓</button>
                  <button onClick={()=>delCat(catMgrEvent,cat)} style={{background:"none",border:`0.5px solid ${C.border}`,borderRadius:6,padding:"3px 8px",fontSize:11,color:"#c03030",cursor:"pointer"}}>Hapus</button>
                </div>
              );
            })}
          </div>
          <div style={{display:"flex",gap:8}}>
            <input value={newCatName} onChange={e=>setNewCatName(e.target.value)} onKeyDown={e=>e.key==="Enter"&&addCat()} placeholder={`Tambah kategori ${catMgrEvent} baru...`} style={{...inp,flex:1}}/>
            <button onClick={addCat} style={btnP}>Tambah</button>
          </div>
          <div style={{fontSize:11,color:C.textMuted,marginTop:8}}>Perubahan langsung tersimpan. Tidak perlu deploy ulang.</div>
        </div>
      )}

      <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:20,flexWrap:"wrap"}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Cari nama atau kategori..." style={{...inp,width:200}}/>
        <select value={filterEvent} onChange={e=>setFilterEvent(e.target.value)} style={{...inp,width:130}}>
          <option>Semua</option>{EVENT_GROUPS.map(g=><option key={g}>{g}</option>)}
        </select>
        <select value={filterStatus} onChange={e=>setFilterStatus(e.target.value)} style={{...inp,width:150}}>
          <option>Semua</option>{STATUS_OPTIONS.map(s=><option key={s}>{s}</option>)}
        </select>
        <div style={{flex:1}}/>
        <button onClick={()=>setShowCatMgr(v=>!v)} style={{...btnO,fontSize:12,padding:"7px 14px"}}>⚙️ Kategori</button>
        <button onClick={()=>setModal({...EMPTY_V})} style={btnP}>+ Tambah vendor</button>
      </div>
      {Object.keys(groups).length===0?<Empty icon="🏪" msg="Belum ada vendor. Tambah yang pertama!"/>
        :EVENT_GROUPS.filter(eg=>groups[eg]).map(eg=>(
          <div key={eg} style={{marginBottom:24}}>
            <Divider label={eg}/>
            {Object.entries(groups[eg]).map(([cat,vlist])=>(
              <div key={cat} style={{marginBottom:14}}>
                <div style={{fontSize:12,color:C.textMuted,fontWeight:600,marginBottom:8}}>{cat}</div>
                <div style={{display:"flex",flexDirection:"column",gap:8}}>
                  {vlist.map(v=>{
                    const st=STATUS_STYLE[v.status]||STATUS_STYLE["Belum Contact"];
                    return(
                      <div key={v.id} style={{...cardS,display:"flex",alignItems:"flex-start",gap:14}}>
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4,flexWrap:"wrap"}}>
                            <span style={{fontSize:14,fontWeight:600,color:C.text}}>{v.nama}</span>
                            <Pill color={st.color} bg={st.bg}>{v.status}</Pill>
                            {v.rating>0&&<Stars value={v.rating}/>}
                          </div>
                          <div style={{display:"flex",gap:14,flexWrap:"wrap",fontSize:12,color:C.textMid}}>
                            {v.harga>0&&<span><span style={{color:C.textMuted}}>Harga:</span> Rp {fmtRp(v.harga)}</span>}
                            {v.pax&&<span><span style={{color:C.textMuted}}>Pax:</span> {v.pax}</span>}
                            {v.hargaPerPax>0&&<span><span style={{color:C.textMuted}}>/pax:</span> Rp {fmtRp(v.hargaPerPax)}</span>}
                            {v.linkIG&&<a href={v.linkIG.startsWith("http")?v.linkIG:"https://"+v.linkIG} target="_blank" rel="noreferrer" style={{color:C.pink,textDecoration:"none"}}>IG ↗</a>}
                            {v.linkWA&&<a href={v.linkWA.startsWith("http")?v.linkWA:"https://"+v.linkWA} target="_blank" rel="noreferrer" style={{color:C.green,textDecoration:"none"}}>WA ↗</a>}
                            {v.linkPricelist&&<a href={v.linkPricelist.startsWith("http")?v.linkPricelist:"https://"+v.linkPricelist} target="_blank" rel="noreferrer" style={{color:C.lav,textDecoration:"none"}}>Pricelist ↗</a>}
                          </div>
                          {v.catatan&&<div style={{marginTop:4,fontSize:12,color:C.textMuted,fontStyle:"italic"}}>{v.catatan}</div>}
                        </div>
                        <div style={{display:"flex",gap:6,flexShrink:0}}>
                          <button onClick={()=>setModal(v)} style={{...btnO,padding:"5px 12px",fontSize:12}}>Edit</button>
                          <button onClick={()=>del(v.id)} style={{background:"none",border:`0.5px solid ${C.border}`,borderRadius:8,padding:"5px 10px",fontSize:12,color:C.textMuted,cursor:"pointer"}}>×</button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        ))}
    </div>
  );
}

// ─── PAGE: SIMULATOR ──────────────────────────────────────────
// picks disimpan permanen di localStorage, bukan state biasa
function SimulatorPage({vendors,budget,picks,setPicks,categoryOptions}) {
  const totalBudget=budget.total||0;

  // Semua kategori tampil: dari categoryOptions (user-managed) + kategori extra dari vendor list
  const allCatsByEvent={};
  EVENT_GROUPS.forEach(eg=>{
    const savedCats=(categoryOptions||DEFAULT_CATEGORIES)[eg]||[];
    const vendorCats=[...new Set(vendors.filter(v=>v.event===eg).map(v=>v.kategori).filter(Boolean))];
    const merged=[...new Set([...savedCats,...vendorCats])];
    allCatsByEvent[eg]=merged;
  });

  const allCats=Object.values(allCatsByEvent).flat();
  const totalPicked=allCats.reduce((s,cat)=>{const v=vendors.find(v=>v.id===picks[cat]);return s+(v?.harga||0);},0);
  const pickedCount=allCats.filter(cat=>picks[cat]).length;
  const totalCats=allCats.length;
  const diff=totalBudget-totalPicked;

  return(
    <div>
      {/* Summary bar */}
      <div style={{background:"linear-gradient(135deg,#fde8f0 0%,#f0ecfa 100%)",border:`0.5px solid ${C.border}`,borderRadius:14,padding:"20px 24px",marginBottom:24}}>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16}}>
          <div>
            <div style={{fontSize:11,color:C.textMuted,marginBottom:3}}>Total budgetku</div>
            <div style={{fontSize:22,fontWeight:700,color:C.pinkDark}}>Rp {fmtRp(totalBudget)}</div>
            {totalBudget===0&&<div style={{fontSize:11,color:C.textMuted}}>Isi dulu di halaman Budget</div>}
          </div>
          <div>
            <div style={{fontSize:11,color:C.textMuted,marginBottom:3}}>Total vendor dipilih</div>
            <div style={{fontSize:22,fontWeight:700,color:C.lav}}>Rp {fmtRp(totalPicked)}</div>
            <div style={{fontSize:11,color:C.textMuted}}>{pickedCount}/{totalCats} kategori dipilih</div>
          </div>
          <div>
            <div style={{fontSize:11,color:C.textMuted,marginBottom:3}}>{diff>=0?"Sisa budget":"Melebihi budget"}</div>
            <div style={{fontSize:22,fontWeight:700,color:diff>=0?C.green:"#c03030"}}>Rp {fmtRp(Math.abs(diff))}</div>
            {totalBudget>0&&<div style={{fontSize:11,color:C.textMuted}}>{diff>=0?"aman":"⚠️ over budget"}</div>}
          </div>
        </div>
        {totalBudget>0&&totalPicked>0&&(
          <div style={{marginTop:14}}>
            <ProgBar pct={Math.round(totalPicked/totalBudget*100)} color={totalPicked>totalBudget?"#c03030":C.lav}/>
            <div style={{fontSize:11,color:C.textMuted,marginTop:4}}>{Math.round(totalPicked/totalBudget*100)}% dari total budget · {totalCats-pickedCount} kategori belum dipilih</div>
          </div>
        )}
      </div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
        <div style={{fontSize:12,color:C.textMuted}}>
          Kategori <span style={{color:C.textMuted,background:"#f5eef2",padding:"2px 8px",borderRadius:20}}>abu</span> = belum ada vendor di list · pilih vendor untuk mengisi
        </div>
        <button onClick={()=>setPicks({})} style={{...btnO,fontSize:12}}>Reset semua</button>
      </div>
      {EVENT_GROUPS.map(eg=>{
        const cats=allCatsByEvent[eg]||[];
        const sub=cats.reduce((s,cat)=>{const v=vendors.find(v=>v.id===picks[cat]);return s+(v?.harga||0);},0);
        return(
          <div key={eg} style={{marginBottom:26}}>
            <Divider label={eg}/>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {cats.map(cat=>{
                const opts=vendors.filter(v=>v.kategori===cat&&v.event===eg);
                const hasVendors=opts.length>0;
                const sel=vendors.find(v=>v.id===picks[cat]);
                const st=sel?(STATUS_STYLE[sel.status]||STATUS_STYLE["Belum Contact"]):null;
                return(
                  <div key={cat} style={{...cardS,display:"grid",gridTemplateColumns:"160px 1fr auto",gap:12,alignItems:"center",opacity:hasVendors?1:0.55,background:hasVendors?C.white:"#fdf8fb"}}>
                    <div>
                      <div style={{fontSize:12,color:hasVendors?C.textMid:C.textMuted,fontWeight:500}}>{cat}</div>
                      {!hasVendors&&<div style={{fontSize:10,color:C.textMuted,marginTop:2}}>Belum ada di list</div>}
                    </div>
                    <select
                      value={picks[cat]||""}
                      onChange={e=>setPicks(p=>({...p,[cat]:e.target.value?Number(e.target.value):null}))}
                      disabled={!hasVendors}
                      style={{...inp,fontSize:13,background:!hasVendors?"#f9f5f7":C.white,color:!hasVendors?C.textMuted:C.text}}
                    >
                      <option value="">{hasVendors?"— Belum pilih —":"— Tambah vendor dulu —"}</option>
                      {opts.map(v=><option key={v.id} value={v.id}>{v.nama}{v.harga?" — Rp "+fmtRp(v.harga):""}{v.status==="Confirmed"?" ✓":""}</option>)}
                    </select>
                    <div style={{minWidth:180,textAlign:"right"}}>
                      {sel?(
                        <div>
                          <div style={{fontSize:15,fontWeight:700,color:C.pinkDark}}>Rp {fmtRp(sel.harga||0)}</div>
                          <div style={{display:"flex",gap:5,justifyContent:"flex-end",alignItems:"center",marginTop:3}}>
                            {sel.rating>0&&<Stars value={sel.rating}/>}
                            <Pill color={st.color} bg={st.bg}>{sel.status}</Pill>
                          </div>
                          {sel.hargaPerPax>0&&sel.pax&&<div style={{fontSize:11,color:C.textMuted,marginTop:2}}>{sel.pax} pax × Rp {fmtRp(sel.hargaPerPax)}</div>}
                          {sel.linkPricelist&&<a href={sel.linkPricelist.startsWith("http")?sel.linkPricelist:"https://"+sel.linkPricelist} target="_blank" rel="noreferrer" style={{fontSize:11,color:C.lav}}>Lihat pricelist ↗</a>}
                        </div>
                      ):<span style={{fontSize:12,color:"#d0b8c8"}}>{hasVendors?"belum dipilih":"—"}</span>}
                    </div>
                  </div>
                );
              })}
            </div>
            {sub>0&&<div style={{textAlign:"right",marginTop:8,fontSize:12,color:C.textMuted}}>Subtotal {eg}: <span style={{fontWeight:700,color:C.pinkDark}}>Rp {fmtRp(sub)}</span></div>}
          </div>
        );
      })}
    </div>
  );
}

// ─── PAGE: BUDGET ─────────────────────────────────────────────
// Budget narik otomatis dari Simulator picks — vendor yang dipilih di simulator
// muncul di sini sebagai baris, tinggal isi DP dan catatan payment
function BudgetPage({budget,setBudget,vendors,picks}) {
  const [editTotal,setEditTotal]=useState(false);
  const [tempTotal,setTempTotal]=useState("");
  const total=budget.total||0;

  // Baris budget = vendor yang dipilih di simulator
  // payments disimpan di budget.payments: { [vendorId]: {dp1,dp1Date,dp2,dp2Date,lunas,lunasDate,catatan} }
  const payments=budget.payments||{};
  const setPayment=(vid,key,val)=>setBudget(b=>({...b,payments:{...(b.payments||{}),[vid]:{...(b.payments||{})[vid],[key]:val}}}));

  // Kumpulkan vendor yang dipilih di simulator berdasarkan picks
  // picks = { [kategori]: vendorId } — iterate semua picks, cari vendornya
  const pickedVendors=[];
  Object.entries(picks).forEach(([cat,vid])=>{
    if(!vid)return;
    const v=vendors.find(v=>v.id===vid);
    if(v&&!pickedVendors.find(p=>p.id===v.id)){
      pickedVendors.push({...v,_cat:cat,_event:v.event});
    }
  });
  // Sort by event order
  const evOrder=EVENT_GROUPS;
  pickedVendors.sort((a,b)=>evOrder.indexOf(a._event)-evOrder.indexOf(b._event));

  const totalHarga=pickedVendors.reduce((s,v)=>s+(v.harga||0),0);
  const totalDP1=pickedVendors.reduce((s,v)=>s+(parseRp(payments[v.id]?.dp1||0)),0);
  const totalDP2=pickedVendors.reduce((s,v)=>s+(parseRp(payments[v.id]?.dp2||0)),0);
  const totalLunas=pickedVendors.reduce((s,v)=>s+(parseRp(payments[v.id]?.lunas||0)),0);
  const totalTerbayar=totalDP1+totalDP2+totalLunas;
  const totalBelum=totalHarga-totalTerbayar;
  const sisaBudget=total-totalHarga;

  const cols=["1fr","110px","120px","120px","120px","110px","100px","140px"];
  const heads=["Vendor / Kategori","Harga (Rp)","DP 1 (Rp)","DP 2 (Rp)","Pelunasan (Rp)","Terbayar","Sisa","Catatan"];

  return(
    <div>
      {/* Summary cards */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:22}}>
        <div style={{...cardS,padding:"14px 16px",cursor:"pointer"}} onClick={()=>{setEditTotal(true);setTempTotal(fmtRp(total));}}>
          <div style={{fontSize:10,color:C.textMuted,textTransform:"uppercase",letterSpacing:"0.05em",marginBottom:4}}>Total anggaran</div>
          {editTotal?(
            <input autoFocus value={tempTotal} onChange={e=>setTempTotal(e.target.value)}
              onBlur={()=>{setBudget(b=>({...b,total:parseRp(tempTotal)}));setEditTotal(false);}}
              onKeyDown={e=>{if(e.key==="Enter"){setBudget(b=>({...b,total:parseRp(tempTotal)}));setEditTotal(false);}}}
              style={{...inp,fontSize:18,fontWeight:700,padding:"2px 4px",border:"none",borderBottom:`1px solid ${C.pink}`,borderRadius:0,background:"transparent",color:C.pinkDark,width:"100%"}}/>
          ):<div style={{fontSize:20,fontWeight:700,color:C.pinkDark}}>Rp {fmtRp(total)}</div>}
          <div style={{fontSize:10,color:C.textMuted,marginTop:4}}>Klik untuk edit</div>
        </div>
        <StatCard label="Total vendor dipilih" value={`Rp ${fmtRp(totalHarga)}`} sub={`${pickedVendors.length} vendor dari Simulator`} accent={C.lav}/>
        <StatCard label="Sudah terbayar" value={`Rp ${fmtRp(totalTerbayar)}`} accent={C.green}/>
        <StatCard label="Belum dibayar" value={`Rp ${fmtRp(Math.max(totalBelum,0))}`} accent={totalBelum>0?"#c03030":C.green}
          sub={total>0?(sisaBudget>=0?`Sisa budget: Rp ${fmtRp(sisaBudget)}`:"⚠️ Over budget"):""}/>
      </div>

      {total>0&&totalHarga>0&&(
        <div style={{marginBottom:20}}>
          <ProgBar pct={Math.round(totalTerbayar/totalHarga*100)} color={C.green}/>
          <div style={{fontSize:11,color:C.textMuted,marginTop:4}}>{Math.round(totalTerbayar/totalHarga*100)}% dari total vendor sudah terbayar</div>
        </div>
      )}

      {pickedVendors.length===0?(
        <div style={{...cardS,textAlign:"center",padding:"40px 0",color:C.textMuted}}>
          <div style={{fontSize:28,marginBottom:8}}>🧮</div>
          <div style={{fontSize:14}}>Pilih vendor dulu di halaman Simulator</div>
          <div style={{fontSize:12,marginTop:4}}>Vendor yang dipilih di Simulator akan otomatis muncul di sini</div>
        </div>
      ):(
        <div style={{...cardS,padding:0,overflow:"auto"}}>
          <div style={{display:"grid",gridTemplateColumns:cols.join(" "),background:C.pinkLight,padding:"10px 14px",borderBottom:`0.5px solid ${C.border}`,minWidth:1000}}>
            {heads.map(h=><div key={h} style={{fontSize:11,fontWeight:600,color:C.pinkDark}}>{h}</div>)}
          </div>
          {EVENT_GROUPS.map(eg=>{
            const evVendors=pickedVendors.filter(v=>v._event===eg);
            if(!evVendors.length)return null;
            return(
              <div key={eg}>
                <div style={{background:"#fdf5f8",padding:"6px 14px",borderBottom:`0.5px solid ${C.border}`,fontSize:11,fontWeight:700,color:C.pink,textTransform:"uppercase",letterSpacing:"0.06em"}}>{eg}</div>
                {evVendors.map((v,idx)=>{
                  const pm=payments[v.id]||{};
                  const dp1=parseRp(pm.dp1||0),dp2=parseRp(pm.dp2||0),lun=parseRp(pm.lunas||0);
                  const terbayar=dp1+dp2+lun;
                  const sisa=Math.max((v.harga||0)-terbayar,0);
                  const lunas=sisa===0&&v.harga>0;
                  return(
                    <div key={v.id} style={{display:"grid",gridTemplateColumns:cols.join(" "),padding:"8px 14px",borderBottom:`0.5px solid ${C.border}`,background:idx%2===0?C.white:"#fffbfd",alignItems:"center",gap:6,minWidth:1000}}>
                      <div>
                        <div style={{fontSize:13,fontWeight:600,color:C.text}}>{v.nama}</div>
                        <div style={{fontSize:11,color:C.textMuted}}>{v._cat}</div>
                        {v.linkPricelist&&<a href={v.linkPricelist.startsWith("http")?v.linkPricelist:"https://"+v.linkPricelist} target="_blank" rel="noreferrer" style={{fontSize:10,color:C.lav}}>Pricelist ↗</a>}
                      </div>
                      <div style={{fontSize:13,fontWeight:600,color:C.text}}>Rp {fmtRp(v.harga||0)}</div>
                      <div>
                        <input value={pm.dp1?fmtRp(pm.dp1):""} onChange={e=>setPayment(v.id,"dp1",parseRp(e.target.value))} placeholder="0" style={{...inp,fontSize:12,marginBottom:3}}/>
                        <input type="date" value={pm.dp1Date||""} onChange={e=>setPayment(v.id,"dp1Date",e.target.value)} style={{...inp,fontSize:10,padding:"3px 6px"}}/>
                      </div>
                      <div>
                        <input value={pm.dp2?fmtRp(pm.dp2):""} onChange={e=>setPayment(v.id,"dp2",parseRp(e.target.value))} placeholder="0" style={{...inp,fontSize:12,marginBottom:3}}/>
                        <input type="date" value={pm.dp2Date||""} onChange={e=>setPayment(v.id,"dp2Date",e.target.value)} style={{...inp,fontSize:10,padding:"3px 6px"}}/>
                      </div>
                      <div>
                        <input value={pm.lunas?fmtRp(pm.lunas):""} onChange={e=>setPayment(v.id,"lunas",parseRp(e.target.value))} placeholder="0" style={{...inp,fontSize:12,marginBottom:3}}/>
                        <input type="date" value={pm.lunasDate||""} onChange={e=>setPayment(v.id,"lunasDate",e.target.value)} style={{...inp,fontSize:10,padding:"3px 6px"}}/>
                      </div>
                      <div style={{fontSize:13,fontWeight:600,color:C.green}}>Rp {fmtRp(terbayar)}</div>
                      <div>
                        <div style={{fontSize:13,fontWeight:600,color:sisa>0?C.amber:C.green}}>Rp {fmtRp(sisa)}</div>
                        {lunas?<Pill color={C.green} bg={C.greenLight}>Lunas</Pill>:terbayar>0?<Pill color={C.amber} bg={C.amberLight}>Belum lunas</Pill>:<Pill color={C.lav} bg={C.lavLight}>Belum DP</Pill>}
                      </div>
                      <input value={pm.catatan||""} onChange={e=>setPayment(v.id,"catatan",e.target.value)} placeholder="catatan..." style={{...inp,fontSize:11}}/>
                    </div>
                  );
                })}
              </div>
            );
          })}
          {/* Total row */}
          <div style={{display:"grid",gridTemplateColumns:cols.join(" "),padding:"10px 14px",background:C.pinkLight,minWidth:1000}}>
            <div style={{fontSize:12,fontWeight:700,color:C.pinkDark}}>Total</div>
            <div style={{fontSize:13,fontWeight:700,color:C.pinkDark}}>Rp {fmtRp(totalHarga)}</div>
            <div style={{fontSize:13,fontWeight:700,color:C.lav}}>Rp {fmtRp(totalDP1)}</div>
            <div style={{fontSize:13,fontWeight:700,color:C.lav}}>Rp {fmtRp(totalDP2)}</div>
            <div style={{fontSize:13,fontWeight:700,color:C.lav}}>Rp {fmtRp(totalLunas)}</div>
            <div style={{fontSize:13,fontWeight:700,color:C.green}}>Rp {fmtRp(totalTerbayar)}</div>
            <div style={{fontSize:13,fontWeight:700,color:totalBelum>0?"#c03030":C.green}}>Rp {fmtRp(Math.max(totalBelum,0))}</div>
            <div/>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── PAGE: GUEST LIST ─────────────────────────────────────────
const EMPTY_G={id:null,nama:"",jumlah:1,namaTamu:"",kelompok:"Keluarga",rsvp:"Belum Konfirm",catatan:""};
function GuestListPage({guests,setGuests}) {
  const [modal,setModal]=useState(null);
  const [filterK,setFilterK]=useState("Semua");
  const [filterR,setFilterR]=useState("Semua");
  const [search,setSearch]=useState("");
  const filtered=guests.filter(g=>{
    if(filterK!=="Semua"&&g.kelompok!==filterK)return false;
    if(filterR!=="Semua"&&g.rsvp!==filterR)return false;
    if(search&&!g.nama.toLowerCase().includes(search.toLowerCase()))return false;
    return true;
  });
  const save=f=>{setGuests(gs=>f.id?gs.map(g=>g.id===f.id?f:g):[...gs,{...f,id:Date.now()}]);setModal(null);};
  const del=id=>{if(window.confirm("Hapus tamu?"))setGuests(gs=>gs.filter(g=>g.id!==id));};
  const totalUndangan=guests.length;
  const totalTamu=guests.reduce((s,g)=>s+(Number(g.jumlah)||1),0);
  const hadir=guests.filter(g=>g.rsvp==="Hadir").reduce((s,g)=>s+(Number(g.jumlah)||1),0);
  const belum=guests.filter(g=>g.rsvp==="Belum Konfirm").length;
  const tidak=guests.filter(g=>g.rsvp==="Tidak Hadir").reduce((s,g)=>s+(Number(g.jumlah)||1),0);
  return(
    <div>
      {modal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(80,40,60,0.2)",zIndex:200,display:"flex",alignItems:"center",justifyContent:"center"}} onClick={()=>setModal(null)}>
          <div style={{background:C.white,borderRadius:16,width:440,padding:"24px 26px",border:`0.5px solid ${C.border}`}} onClick={e=>e.stopPropagation()}>
            <div style={{fontSize:15,fontWeight:600,color:C.pinkDark,marginBottom:18}}>{modal.id?"Edit undangan":"Tambah undangan"}</div>
            <div style={{marginBottom:12}}><Lbl>Nama undangan * <span style={{color:C.textMuted,fontWeight:400}}>(nama orang/keluarga yang diundang)</span></Lbl><input value={modal.nama} onChange={e=>setModal(m=>({...m,nama:e.target.value}))} placeholder="contoh: Keluarga Budi / Sinta" style={inp}/></div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
              <div><Lbl>Jumlah tamu</Lbl><input type="number" min={1} value={modal.jumlah||1} onChange={e=>setModal(m=>({...m,jumlah:Math.max(1,parseInt(e.target.value)||1)}))} style={inp}/></div>
              <div><Lbl>Kelompok</Lbl><select value={modal.kelompok} onChange={e=>setModal(m=>({...m,kelompok:e.target.value}))} style={inp}>{KELOMPOK.map(k=><option key={k}>{k}</option>)}</select></div>
            </div>
            <div style={{marginBottom:12}}><Lbl>Nama-nama tamu <span style={{color:C.textMuted,fontWeight:400}}>(opsional, pisah koma)</span></Lbl><input value={modal.namaTamu||""} onChange={e=>setModal(m=>({...m,namaTamu:e.target.value}))} placeholder="contoh: Budi, Ani, Deni, Sari" style={inp}/></div>
            <div style={{marginBottom:12}}><Lbl>RSVP</Lbl><select value={modal.rsvp} onChange={e=>setModal(m=>({...m,rsvp:e.target.value}))} style={inp}>{["Belum Konfirm","Hadir","Tidak Hadir"].map(r=><option key={r}>{r}</option>)}</select></div>
            <div style={{marginBottom:18}}><Lbl>Catatan</Lbl><input value={modal.catatan} onChange={e=>setModal(m=>({...m,catatan:e.target.value}))} style={inp}/></div>
            <div style={{display:"flex",justifyContent:"flex-end",gap:10}}>
              <button onClick={()=>setModal(null)} style={btnO}>Batal</button>
              <button onClick={()=>{if(!modal.nama.trim())return alert("Nama wajib diisi.");save(modal);}} style={btnP}>Simpan</button>
            </div>
          </div>
        </div>
      )}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:20}}>
        <StatCard label="Total undangan" value={totalUndangan} sub="jumlah kartu/nama" accent={C.pink}/>
        <StatCard label="Total tamu" value={totalTamu} sub="total orang" accent={C.lav}/>
        <StatCard label="Tamu hadir" value={hadir} sub={`${belum} undangan belum konfirm`} accent={C.green}/>
        <StatCard label="Tidak hadir" value={tidak} sub="total orang" accent="#c03030"/>
      </div>
      <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:18,flexWrap:"wrap"}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Cari nama..." style={{...inp,width:200}}/>
        <select value={filterK} onChange={e=>setFilterK(e.target.value)} style={{...inp,width:150}}><option>Semua</option>{KELOMPOK.map(k=><option key={k}>{k}</option>)}</select>
        <select value={filterR} onChange={e=>setFilterR(e.target.value)} style={{...inp,width:160}}><option>Semua</option>{["Hadir","Tidak Hadir","Belum Konfirm"].map(r=><option key={r}>{r}</option>)}</select>
        <div style={{flex:1}}/>
        <button onClick={()=>setModal({...EMPTY_G})} style={btnP}>+ Tambah undangan</button>
      </div>
      {filtered.length===0?<Empty icon="👥" msg="Belum ada tamu."/>:(
        <div style={{...cardS,padding:0,overflow:"hidden"}}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 60px 160px 120px 110px auto",background:C.pinkLight,padding:"10px 16px",borderBottom:`0.5px solid ${C.border}`}}>
            {["Nama Undangan","Jml","Nama-nama Tamu","Kelompok","RSVP",""].map((h,i)=><div key={i} style={{fontSize:11,fontWeight:600,color:C.pinkDark}}>{h}</div>)}
          </div>
          {filtered.map((g,idx)=>{const rs=RSVP_STYLE[g.rsvp]||RSVP_STYLE["Belum Konfirm"];return(
            <div key={g.id} style={{display:"grid",gridTemplateColumns:"1fr 60px 160px 120px 110px auto",padding:"9px 16px",borderBottom:`0.5px solid ${C.border}`,background:idx%2===0?C.white:"#fffbfd",alignItems:"center",gap:8}}>
              <div>
                <div style={{fontSize:13,color:C.text,fontWeight:500}}>{g.nama}</div>
                {g.catatan&&<div style={{fontSize:11,color:C.textMuted,fontStyle:"italic",marginTop:2}}>{g.catatan}</div>}
              </div>
              <div style={{fontSize:13,fontWeight:600,color:C.pinkDark,textAlign:"center"}}>{Number(g.jumlah)||1}</div>
              <div style={{fontSize:11,color:C.textMuted}}>{g.namaTamu||<span style={{color:"#ddd"}}>—</span>}</div>
              <div style={{fontSize:12,color:C.textMuted}}>{g.kelompok}</div>
              <Pill color={rs.color} bg={rs.bg}>{g.rsvp}</Pill>
              <div style={{display:"flex",gap:6}}>
                <button onClick={()=>setModal(g)} style={{...btnO,padding:"4px 10px",fontSize:11}}>Edit</button>
                <button onClick={()=>del(g.id)} style={{background:"none",border:`0.5px solid ${C.border}`,borderRadius:8,padding:"4px 8px",fontSize:11,color:C.textMuted,cursor:"pointer"}}>×</button>
              </div>
            </div>
          );})}
          <div style={{display:"grid",gridTemplateColumns:"1fr 60px 160px 120px 110px auto",padding:"10px 16px",background:C.pinkLight,borderTop:`0.5px solid ${C.border}`}}>
            <div style={{fontSize:12,fontWeight:700,color:C.pinkDark}}>{totalUndangan} undangan</div>
            <div style={{fontSize:13,fontWeight:700,color:C.pinkDark,textAlign:"center"}}>{totalTamu}</div>
            <div style={{fontSize:11,color:C.textMuted}}>total tamu</div>
            <div/>
            <div/>
            <div/>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── PAGE: TIMELINE ───────────────────────────────────────────
function TimelinePage({timeline,setTimeline}) {
  const [editing,setEditing]=useState(null);
  const [newRow,setNewRow]=useState({time:"",activity:"",pic:""});
  const update=(id,key,val)=>setTimeline(ts=>ts.map(t=>t.id===id?{...t,[key]:val}:t));
  const del=id=>setTimeline(ts=>ts.filter(t=>t.id!==id));
  const add=()=>{
    if(!newRow.time||!newRow.activity)return alert("Waktu dan kegiatan wajib diisi.");
    setTimeline(ts=>[...ts,{...newRow,id:Date.now()}].sort((a,b)=>a.time.localeCompare(b.time)));
    setNewRow({time:"",activity:"",pic:""});
  };
  const sorted=[...timeline].sort((a,b)=>a.time.localeCompare(b.time));
  return(
    <div>
      <div style={{...cardS,marginBottom:20}}>
        <div style={{fontSize:13,fontWeight:600,color:C.pinkDark,marginBottom:12}}>Tambah kegiatan</div>
        <div style={{display:"grid",gridTemplateColumns:"110px 1fr 140px auto",gap:10,alignItems:"end"}}>
          <div><Lbl>Waktu</Lbl><input value={newRow.time} onChange={e=>setNewRow(r=>({...r,time:e.target.value}))} placeholder="08.00" style={inp}/></div>
          <div><Lbl>Kegiatan</Lbl><input value={newRow.activity} onChange={e=>setNewRow(r=>({...r,activity:e.target.value}))} placeholder="Makeup bride dimulai" style={inp}/></div>
          <div><Lbl>PIC</Lbl><input value={newRow.pic} onChange={e=>setNewRow(r=>({...r,pic:e.target.value}))} placeholder="Bride, WO, dst" style={inp}/></div>
          <button onClick={add} style={{...btnP,alignSelf:"end"}}>Tambah</button>
        </div>
      </div>
      {sorted.length===0?<Empty icon="🕐" msg="Belum ada agenda hari H."/>:(
        <div style={{position:"relative"}}>
          <div style={{position:"absolute",left:54,top:10,bottom:10,width:"0.5px",background:C.border}}/>
          {sorted.map(t=>(
            <div key={t.id} style={{display:"flex",gap:0,alignItems:"flex-start",marginBottom:8}}>
              <div style={{width:54,flexShrink:0,textAlign:"right",paddingRight:14,paddingTop:10}}>
                {editing===t.id?<input value={t.time} onChange={e=>update(t.id,"time",e.target.value)} style={{...inp,width:46,fontSize:11,padding:"3px 4px",textAlign:"center"}}/>
                  :<span style={{fontSize:12,fontWeight:600,color:C.pink}}>{t.time}</span>}
              </div>
              <div style={{width:10,height:10,borderRadius:"50%",background:C.pink,border:`2px solid ${C.white}`,flexShrink:0,marginTop:12,boxShadow:`0 0 0 1px ${C.border}`}}/>
              <div style={{flex:1,...cardS,marginLeft:12,padding:"10px 14px"}}>
                {editing===t.id?(
                  <div style={{display:"grid",gridTemplateColumns:"1fr 130px auto auto",gap:8,alignItems:"center"}}>
                    <input value={t.activity} onChange={e=>update(t.id,"activity",e.target.value)} style={{...inp,fontSize:13}}/>
                    <input value={t.pic} onChange={e=>update(t.id,"pic",e.target.value)} placeholder="PIC" style={{...inp,fontSize:12}}/>
                    <button onClick={()=>setEditing(null)} style={{...btnP,padding:"6px 12px",fontSize:12}}>Selesai</button>
                    <button onClick={()=>del(t.id)} style={{background:"none",border:`0.5px solid ${C.border}`,borderRadius:8,padding:"6px 8px",fontSize:12,color:C.textMuted,cursor:"pointer"}}>×</button>
                  </div>
                ):(
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <div style={{flex:1}}>
                      <div style={{fontSize:13,color:C.text,fontWeight:500}}>{t.activity}</div>
                      {t.pic&&<div style={{fontSize:11,color:C.textMuted,marginTop:2}}>PIC: {t.pic}</div>}
                    </div>
                    <button onClick={()=>setEditing(t.id)} style={{...btnO,padding:"4px 10px",fontSize:11}}>Edit</button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── PAGE: KALENDER ───────────────────────────────────────────
function KalenderPage({checklist,vendors}) {
  const [viewDate,setViewDate]=useState(new Date());
  const year=viewDate.getFullYear(), month=viewDate.getMonth();
  const monthNames=["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];
  const dayNames=["Min","Sen","Sel","Rab","Kam","Jum","Sab"];
  const firstDay=new Date(year,month,1).getDay();
  const daysInMonth=new Date(year,month+1,0).getDate();

  // Collect events: checklist deadlines + vendor jatuh tempo
  const events={};
  checklist.filter(c=>c.deadline).forEach(c=>{
    const d=c.deadline; // "YYYY-MM-DD"
    if(!events[d])events[d]=[];
    events[d].push({type:"checklist",label:c.text,done:c.done});
  });
  vendors.filter(v=>v.jatuhTempo).forEach(v=>{
    const d=v.jatuhTempo;
    if(!events[d])events[d]=[];
    events[d].push({type:"vendor",label:v.nama+" ("+v.kategori+")"});
  });

  const today=new Date(); today.setHours(0,0,0,0);
  const prev=()=>setViewDate(new Date(year,month-1,1));
  const next=()=>setViewDate(new Date(year,month+1,1));

  const cells=[];
  for(let i=0;i<firstDay;i++)cells.push(null);
  for(let d=1;d<=daysInMonth;d++)cells.push(d);

  const isToday=(d)=>{const t=new Date(year,month,d);t.setHours(0,0,0,0);return t.getTime()===today.getTime();};
  const isWedding=(d)=>(year===2027&&month===6&&d===17);
  const dateKey=(d)=>`${year}-${String(month+1).padStart(2,"0")}-${String(d).padStart(2,"0")}`;

  return(
    <div>
      {/* Legend */}
      <div style={{display:"flex",gap:16,marginBottom:16,flexWrap:"wrap"}}>
        <div style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:C.textMuted}}><div style={{width:10,height:10,borderRadius:"50%",background:C.pink}}/> Deadline checklist</div>
        <div style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:C.textMuted}}><div style={{width:10,height:10,borderRadius:"50%",background:C.lav}}/> Jatuh tempo vendor</div>
        <div style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:C.textMuted}}><div style={{width:10,height:10,borderRadius:"50%",background:"#e8a045"}}/> Hari H</div>
      </div>
      <div style={{...cardS,padding:0,overflow:"hidden"}}>
        {/* Nav */}
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 20px",borderBottom:`0.5px solid ${C.border}`,background:C.pinkLight}}>
          <button onClick={prev} style={{...btnO,padding:"6px 14px",fontSize:13}}>‹</button>
          <span style={{fontSize:15,fontWeight:600,color:C.pinkDark}}>{monthNames[month]} {year}</span>
          <button onClick={next} style={{...btnO,padding:"6px 14px",fontSize:13}}>›</button>
        </div>
        {/* Day headers */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",borderBottom:`0.5px solid ${C.border}`}}>
          {dayNames.map(d=><div key={d} style={{padding:"8px 0",textAlign:"center",fontSize:11,fontWeight:600,color:C.textMuted}}>{d}</div>)}
        </div>
        {/* Grid */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)"}}>
          {cells.map((d,i)=>{
            if(!d) return <div key={`e${i}`} style={{minHeight:80,borderRight:`0.5px solid ${C.border}`,borderBottom:`0.5px solid ${C.border}`,background:"#fdf8fb"}}/>;
            const key=dateKey(d);
            const dayEvents=events[key]||[];
            const wed=isWedding(d), tod=isToday(d);
            return(
              <div key={d} style={{minHeight:80,padding:"6px 8px",borderRight:`0.5px solid ${C.border}`,borderBottom:`0.5px solid ${C.border}`,background:wed?"#fff8e6":tod?C.pinkLight:C.white,position:"relative"}}>
                <div style={{fontSize:12,fontWeight:wed||tod?700:400,color:wed?"#e8a045":tod?C.pink:C.text,marginBottom:4,width:22,height:22,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",background:tod?C.pink:"transparent",color:tod?"white":wed?"#e8a045":C.text}}>{d}</div>
                {wed&&<div style={{fontSize:9,color:"#e8a045",fontWeight:700}}>💍 Hari H!</div>}
                {dayEvents.slice(0,2).map((ev,ei)=>(
                  <div key={ei} style={{fontSize:9,padding:"1px 5px",borderRadius:4,marginBottom:2,background:ev.type==="checklist"?C.pinkLight:C.lavLight,color:ev.type==="checklist"?C.pink:C.lav,overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"}}>
                    {ev.label}
                  </div>
                ))}
                {dayEvents.length>2&&<div style={{fontSize:9,color:C.textMuted}}>+{dayEvents.length-2} lagi</div>}
              </div>
            );
          })}
        </div>
      </div>
      <div style={{fontSize:12,color:C.textMuted,marginTop:12}}>
        Deadline muncul otomatis dari Checklist. Tambah deadline di halaman Checklist, atau jatuh tempo di halaman Vendor List.
      </div>
    </div>
  );
}

// ─── PAGE: MOODBOARD ──────────────────────────────────────────
function MoodboardPage({title,storageKey,accentColor,icon}) {
  const [images,setImages]=useState(()=>loadS(storageKey,[]));
  const [notes,setNotes]=useState(()=>loadS(storageKey+"_notes",""));
  const fileRef=useRef();
  useEffect(()=>{localStorage.setItem(storageKey,JSON.stringify(images));},[images,storageKey]);
  useEffect(()=>{localStorage.setItem(storageKey+"_notes",notes);},[notes,storageKey]);

  const addImages=e=>{
    const files=Array.from(e.target.files);
    files.forEach(file=>{
      const reader=new FileReader();
      reader.onload=ev=>{
        setImages(imgs=>[...imgs,{id:Date.now()+Math.random(),src:ev.target.result,caption:"",file:file.name}]);
      };
      reader.readAsDataURL(file);
    });
    e.target.value="";
  };

  const del=id=>setImages(imgs=>imgs.filter(i=>i.id!==id));
  const setCaption=(id,v)=>setImages(imgs=>imgs.map(i=>i.id===id?{...i,caption:v}:i));

  const exportPDF=()=>{
    const win=window.open("","_blank");
    const html=`<!DOCTYPE html><html><head><meta charset="utf-8">
    <title>${title} - Tatiana & Matheus</title>
    <style>
      body{font-family:Georgia,serif;margin:0;padding:32px;background:#fffbfd;color:#3d2030;}
      h1{font-size:28px;color:${accentColor};margin-bottom:4px;}
      .sub{font-size:13px;color:#a07090;margin-bottom:24px;}
      .notes{font-size:13px;color:#7a5060;margin-bottom:28px;padding:14px 18px;background:#fde8f0;border-radius:10px;line-height:1.7;}
      .grid{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;}
      .item{break-inside:avoid;}
      .item img{width:100%;border-radius:8px;display:block;}
      .caption{font-size:11px;color:#a07090;margin-top:6px;text-align:center;}
      .footer{margin-top:40px;text-align:center;font-size:11px;color:#c0a0b0;}
      @media print{body{padding:16px;}}
    </style></head><body>
    <h1>${icon} ${title}</h1>
    <div class="sub">Tatiana & Matheus · 17 Juli 2027</div>
    ${notes?`<div class="notes">${notes.replace(/\n/g,"<br>")}</div>`:""}
    <div class="grid">${images.map(img=>`<div class="item"><img src="${img.src}" alt="${img.caption||""}"/>${img.caption?`<div class="caption">${img.caption}</div>`:""}</div>`).join("")}</div>
    <div class="footer">Generated dari Wedding Planner · Tatiana & Matheus</div>
    </body></html>`;
    win.document.write(html);
    win.document.close();
    setTimeout(()=>win.print(),600);
  };

  return(
    <div>
      <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:20,flexWrap:"wrap"}}>
        <button onClick={()=>fileRef.current.click()} style={btnP}>+ Tambah gambar</button>
        <input ref={fileRef} type="file" accept="image/*" multiple onChange={addImages} style={{display:"none"}}/>
        {images.length>0&&<button onClick={exportPDF} style={{...btnO,display:"flex",alignItems:"center",gap:6}}>↓ Export PDF</button>}
        <div style={{flex:1}}/>
        <span style={{fontSize:12,color:C.textMuted}}>{images.length} gambar</span>
      </div>

      {/* Notes/konsep */}
      <div style={{...cardS,marginBottom:20}}>
        <div style={{fontSize:13,fontWeight:600,color:C.pinkDark,marginBottom:8}}>Catatan konsep & referensi</div>
        <textarea value={notes} onChange={e=>setNotes(e.target.value)} placeholder="Tuliskan konsep, warna, tema, referensi, atau catatan lainnya..." rows={3} style={{...inp,resize:"vertical"}}/>
      </div>

      {images.length===0?(
        <div style={{border:`2px dashed ${C.border}`,borderRadius:16,padding:"60px 0",textAlign:"center",color:C.textMuted,cursor:"pointer"}} onClick={()=>fileRef.current.click()}>
          <div style={{fontSize:40,marginBottom:10}}>{icon}</div>
          <div style={{fontSize:14}}>Klik untuk upload gambar inspirasi</div>
          <div style={{fontSize:12,marginTop:4}}>JPG, PNG, WebP didukung</div>
        </div>
      ):(
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:14}}>
          {images.map(img=>(
            <div key={img.id} style={{...cardS,padding:0,overflow:"hidden",position:"relative"}}>
              <img src={img.src} alt={img.caption||""} style={{width:"100%",display:"block",maxHeight:200,objectFit:"cover"}}/>
              <button onClick={()=>del(img.id)} style={{position:"absolute",top:6,right:6,background:"rgba(80,40,60,0.7)",border:"none",color:"white",borderRadius:"50%",width:22,height:22,cursor:"pointer",fontSize:13,lineHeight:1,display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>
              <div style={{padding:"8px 10px"}}>
                <input value={img.caption} onChange={e=>setCaption(img.id,e.target.value)} placeholder="Tulis caption..." style={{...inp,fontSize:12,padding:"5px 8px"}}/>
              </div>
            </div>
          ))}
          <div style={{border:`2px dashed ${C.border}`,borderRadius:12,display:"flex",alignItems:"center",justifyContent:"center",minHeight:200,cursor:"pointer",color:C.textMuted,flexDirection:"column",gap:8}} onClick={()=>fileRef.current.click()}>
            <div style={{fontSize:24}}>+</div>
            <div style={{fontSize:12}}>Tambah gambar</div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── PAGE: PLAYLIST ───────────────────────────────────────────
const EMPTY_SONG={id:null,judul:"",artis:"",segmen:"Lainnya",linkSpotify:"",linkYT:"",catatan:""};
function PlaylistPage({playlist,setPlaylist}) {
  const [modal,setModal]=useState(null);
  const [filterSeg,setFilterSeg]=useState("Semua");
  const filtered=playlist.filter(s=>filterSeg==="Semua"||s.segmen===filterSeg);
  const save=f=>{setPlaylist(ps=>f.id?ps.map(s=>s.id===f.id?f:s):[...ps,{...f,id:Date.now()}]);setModal(null);};
  const del=id=>{if(window.confirm("Hapus lagu ini?"))setPlaylist(ps=>ps.filter(s=>s.id!==id));};

  const grouped={};
  filtered.forEach(s=>{if(!grouped[s.segmen])grouped[s.segmen]=[];grouped[s.segmen].push(s);});
  const SEGMEN_ORDER=SEGMEN_OPTIONS;
  const sortedSegs=Object.keys(grouped).sort((a,b)=>SEGMEN_ORDER.indexOf(a)-SEGMEN_ORDER.indexOf(b));

  return(
    <div>
      {modal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(80,40,60,0.2)",zIndex:200,display:"flex",alignItems:"center",justifyContent:"center"}} onClick={()=>setModal(null)}>
          <div style={{background:C.white,borderRadius:16,width:460,padding:"24px 26px",border:`0.5px solid ${C.border}`}} onClick={e=>e.stopPropagation()}>
            <div style={{fontSize:15,fontWeight:600,color:C.pinkDark,marginBottom:18}}>{modal.id?"Edit lagu":"Tambah lagu"}</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px 14px"}}>
              <div style={{gridColumn:"1/-1"}}><Lbl>Judul lagu *</Lbl><input value={modal.judul} onChange={e=>setModal(m=>({...m,judul:e.target.value}))} style={inp}/></div>
              <div><Lbl>Artis</Lbl><input value={modal.artis} onChange={e=>setModal(m=>({...m,artis:e.target.value}))} placeholder="Taylor Swift, dll" style={inp}/></div>
              <div><Lbl>Segmen acara</Lbl><select value={modal.segmen} onChange={e=>setModal(m=>({...m,segmen:e.target.value}))} style={inp}>{SEGMEN_OPTIONS.map(s=><option key={s}>{s}</option>)}</select></div>
              <div><Lbl>Link Spotify</Lbl><input value={modal.linkSpotify} onChange={e=>setModal(m=>({...m,linkSpotify:e.target.value}))} placeholder="open.spotify.com/..." style={inp}/></div>
              <div><Lbl>Link YouTube</Lbl><input value={modal.linkYT} onChange={e=>setModal(m=>({...m,linkYT:e.target.value}))} placeholder="youtube.com/..." style={inp}/></div>
              <div style={{gridColumn:"1/-1"}}><Lbl>Catatan</Lbl><input value={modal.catatan} onChange={e=>setModal(m=>({...m,catatan:e.target.value}))} placeholder="Untuk momen apa, instruksi ke MC, dll" style={inp}/></div>
            </div>
            <div style={{display:"flex",justifyContent:"flex-end",gap:10,marginTop:18}}>
              <button onClick={()=>setModal(null)} style={btnO}>Batal</button>
              <button onClick={()=>{if(!modal.judul.trim())return alert("Judul wajib diisi.");save(modal);}} style={btnP}>Simpan</button>
            </div>
          </div>
        </div>
      )}
      <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:20,flexWrap:"wrap"}}>
        <select value={filterSeg} onChange={e=>setFilterSeg(e.target.value)} style={{...inp,width:180}}><option>Semua</option>{SEGMEN_OPTIONS.map(s=><option key={s}>{s}</option>)}</select>
        <div style={{flex:1}}/>
        <span style={{fontSize:12,color:C.textMuted}}>{playlist.length} lagu</span>
        <button onClick={()=>setModal({...EMPTY_SONG})} style={btnP}>+ Tambah lagu</button>
      </div>
      {playlist.length===0?<Empty icon="🎵" msg="Belum ada lagu. Mulai susun playlist impianmu!"/>
        :sortedSegs.map(seg=>(
          <div key={seg} style={{marginBottom:22}}>
            <Divider label={seg}/>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {grouped[seg].map((s,idx)=>(
                <div key={s.id} style={{...cardS,display:"flex",alignItems:"center",gap:14}}>
                  <div style={{width:28,height:28,borderRadius:"50%",background:C.pinkLight,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontSize:12,fontWeight:700,color:C.pink}}>{idx+1}</div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:13,fontWeight:600,color:C.text}}>{s.judul}</div>
                    {s.artis&&<div style={{fontSize:12,color:C.textMuted}}>{s.artis}</div>}
                    {s.catatan&&<div style={{fontSize:11,color:C.textMuted,fontStyle:"italic",marginTop:2}}>{s.catatan}</div>}
                  </div>
                  <div style={{display:"flex",gap:8,alignItems:"center",flexShrink:0}}>
                    {s.linkSpotify&&<a href={s.linkSpotify.startsWith("http")?s.linkSpotify:"https://"+s.linkSpotify} target="_blank" rel="noreferrer" style={{fontSize:11,background:"#e8f8e8",color:"#2d7a50",padding:"3px 10px",borderRadius:20,textDecoration:"none"}}>Spotify ↗</a>}
                    {s.linkYT&&<a href={s.linkYT.startsWith("http")?s.linkYT:"https://"+s.linkYT} target="_blank" rel="noreferrer" style={{fontSize:11,background:"#fee8e8",color:"#a03030",padding:"3px 10px",borderRadius:20,textDecoration:"none"}}>YT ↗</a>}
                    <button onClick={()=>setModal(s)} style={{...btnO,padding:"4px 10px",fontSize:11}}>Edit</button>
                    <button onClick={()=>del(s.id)} style={{background:"none",border:`0.5px solid ${C.border}`,borderRadius:8,padding:"4px 8px",fontSize:11,color:C.textMuted,cursor:"pointer"}}>×</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
    </div>
  );
}


// ─── PAGE: VISION BOARD ───────────────────────────────────────
function VisionBoardPage({vendors,picks,categoryOptions}) {
  const [mode,setMode]=useState("visi"); // "visi" | "bandingkan"
  const [presentasi,setPresentasi]=useState(false);
  const [lightbox,setLightbox]=useState(null);
  const [selKat,setSelKat]=useState(null); // untuk mode bandingkan

  // Semua kategori dari semua event
  const allCats=EVENT_GROUPS.flatMap(eg=>(categoryOptions||DEFAULT_CATEGORIES)[eg]||[]);

  // Vendor yang dipilih: picks = { kategori: vendorId }
  const pickedVendor=(kat)=>vendors.find(v=>v.id===picks[kat]);

  // Semua kategori yang punya vendor dipilih
  const pickedKats=allCats.filter(kat=>picks[kat]&&pickedVendor(kat));

  // Untuk mode visi: per kategori → brief ⭐ + portofolio ⭐ dari vendor dipilih
  const visiData=pickedKats.map(kat=>{
    const v=pickedVendor(kat);
    const briefStarred=(v.brief||[]).filter(p=>p.starred);
    const portfolioStarred=(v.portfolio||[]).filter(p=>p.starred);
    return {kat,vendor:v,briefStarred,portfolioStarred,hasContent:briefStarred.length>0||portfolioStarred.length>0};
  }).filter(d=>d.hasContent);

  // Untuk mode bandingkan: semua vendor per kategori
  const activeVendors=vendors.filter(v=>v.status!=="Cancel");
  const katWithVendors=allCats.filter(kat=>activeVendors.some(v=>v.kategori===kat));
  const selKatFinal=selKat&&katWithVendors.includes(selKat)?selKat:(katWithVendors[0]||null);
  const vendorsInKat=activeVendors.filter(v=>v.kategori===selKatFinal);

  // ── LIGHTBOX ─────────────────────────────────────────────────
  const Lightbox=()=>lightbox?(
    <div onClick={()=>setLightbox(null)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.9)",zIndex:500,display:"flex",alignItems:"center",justifyContent:"center",cursor:"zoom-out"}}>
      <div onClick={e=>e.stopPropagation()} style={{maxWidth:"90vw",maxHeight:"92vh",display:"flex",flexDirection:"column",alignItems:"center",gap:10}}>
        <img src={lightbox.src} alt="" style={{maxWidth:"100%",maxHeight:"82vh",objectFit:"contain",borderRadius:10}}/>
        {lightbox.caption&&<div style={{fontSize:13,color:"#e8d0d8",textAlign:"center"}}>{lightbox.caption}</div>}
        {lightbox.label&&<div style={{fontSize:11,color:"#a07080",textAlign:"center"}}>{lightbox.label}</div>}
        <button onClick={()=>setLightbox(null)} style={{background:"rgba(255,255,255,0.1)",border:"none",borderRadius:8,padding:"5px 18px",color:"#fff",cursor:"pointer",fontSize:12}}>Tutup</button>
      </div>
    </div>
  ):null;

  // ── MODE PRESENTASI ──────────────────────────────────────────
  if(presentasi){
    return(
      <div style={{position:"fixed",inset:0,background:"#160a10",zIndex:300,overflowY:"auto"}}>
        <Lightbox/>
        <div style={{position:"sticky",top:0,zIndex:10,background:"rgba(22,10,16,0.96)",backdropFilter:"blur(10px)",padding:"14px 40px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:"0.5px solid #3a1525"}}>
          <div>
            <div style={{fontSize:10,color:"#c090a8",letterSpacing:"0.14em",textTransform:"uppercase",marginBottom:2}}>Tatiana & Matheus · 17 Juli 2027</div>
            <div style={{fontSize:17,fontWeight:700,color:"#fff"}}>✨ Visi Pernikahan Kami</div>
          </div>
          <button onClick={()=>setPresentasi(false)} style={{background:"rgba(255,255,255,0.08)",border:"0.5px solid rgba(255,255,255,0.15)",borderRadius:8,padding:"7px 16px",fontSize:12,color:"#fff",cursor:"pointer"}}>✕ Keluar</button>
        </div>
        <div style={{padding:"48px 56px",maxWidth:1100,margin:"0 auto"}}>
          {visiData.length===0?(
            <div style={{textAlign:"center",padding:"100px 0",color:"#a07080"}}>
              <div style={{fontSize:44,marginBottom:14}}>🎯</div>
              <div style={{fontSize:16,marginBottom:8,color:"#d0a0b0"}}>Belum ada konten untuk ditampilkan</div>
              <div style={{fontSize:12,opacity:0.6}}>Pilih vendor di Simulator, lalu tambah foto portofolio & referensi (bintangi yang terbaik) di Vendor List</div>
            </div>
          ):visiData.map(({kat,vendor,briefStarred,portfolioStarred})=>(
            <div key={kat} style={{marginBottom:64}}>
              {/* Section header */}
              <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:24}}>
                <div style={{height:"0.5px",width:32,background:"#4a1a2a"}}/>
                <div>
                  <div style={{fontSize:10,color:"#c090a8",letterSpacing:"0.14em",textTransform:"uppercase",fontWeight:600}}>{kat}</div>
                  <div style={{fontSize:13,color:"#e0b0c0",marginTop:1}}>{vendor.nama}</div>
                </div>
                <div style={{flex:1,height:"0.5px",background:"#4a1a2a"}}/>
              </div>
              {/* Referensi: apa yang diinginkan */}
              {briefStarred.length>0&&(
                <div style={{marginBottom:20}}>
                  <div style={{fontSize:10,color:"#a06820",letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:10,display:"flex",alignItems:"center",gap:8}}>
                    <span style={{width:20,height:"0.5px",background:"#a06820",display:"inline-block"}}/>
                    🎯 Yang Kami Inginkan
                  </div>
                  <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:14}}>
                    {briefStarred.map(p=>(
                      <div key={p.id} onClick={()=>setLightbox({...p,label:`Referensi · ${kat}`})} style={{borderRadius:12,overflow:"hidden",cursor:"zoom-in",aspectRatio:"4/3",position:"relative",background:"#2a1020",border:"0.5px solid #a0682044"}}>
                        <img src={p.src} alt={p.caption||""} style={{width:"100%",height:"100%",objectFit:"cover"}}/>
                        {p.caption&&<div style={{position:"absolute",bottom:0,left:0,right:0,background:"linear-gradient(transparent,rgba(0,0,0,0.75))",padding:"18px 12px 10px",fontSize:11,color:"#fff"}}>{p.caption}</div>}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {/* Portofolio: kemampuan vendor */}
              {portfolioStarred.length>0&&(
                <div>
                  <div style={{fontSize:10,color:"#7c6fbf",letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:10,display:"flex",alignItems:"center",gap:8}}>
                    <span style={{width:20,height:"0.5px",background:"#7c6fbf",display:"inline-block"}}/>
                    📁 Portofolio {vendor.nama}
                  </div>
                  <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:14}}>
                    {portfolioStarred.map(p=>(
                      <div key={p.id} onClick={()=>setLightbox({...p,label:`Portofolio ${vendor.nama} · ${kat}`})} style={{borderRadius:12,overflow:"hidden",cursor:"zoom-in",aspectRatio:"4/3",position:"relative",background:"#1a0d1a",border:"0.5px solid #7c6fbf44"}}>
                        <img src={p.src} alt={p.caption||""} style={{width:"100%",height:"100%",objectFit:"cover"}}/>
                        {p.caption&&<div style={{position:"absolute",bottom:0,left:0,right:0,background:"linear-gradient(transparent,rgba(0,0,0,0.75))",padding:"18px 12px 10px",fontSize:11,color:"#fff"}}>{p.caption}</div>}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }

  // ── MODE EDIT ────────────────────────────────────────────────
  return(
    <div>
      <Lightbox/>
      {/* Top bar */}
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:22,flexWrap:"wrap",gap:10}}>
        <div style={{display:"flex",gap:6}}>
          {[["visi","✨ Tatiana & Matheus"],["bandingkan","⚖️ Bandingkan Vendor"]].map(([m,label])=>(
            <button key={m} onClick={()=>setMode(m)}
              style={{...mode===m?btnP:btnO,padding:"7px 16px",fontSize:12}}>
              {label}
            </button>
          ))}
        </div>
        {mode==="visi"&&(
          <button onClick={()=>setPresentasi(true)}
            style={{background:"linear-gradient(135deg,#8b3a56,#7c6fbf)",color:"#fff",border:"none",borderRadius:8,padding:"8px 18px",fontSize:13,fontWeight:500,cursor:"pointer",fontFamily:"inherit"}}>
            ▶ Mulai Presentasi {visiData.length>0&&`(${visiData.length} kategori)`}
          </button>
        )}
      </div>

      {/* ── MODE VISI ─────────────────────────────────────────── */}
      {mode==="visi"&&(
        <div>
          {pickedKats.length===0?(
            <div style={{...cardS,textAlign:"center",padding:"60px 0",color:C.textMuted}}>
              <div style={{fontSize:36,marginBottom:12}}>🎯</div>
              <div style={{fontSize:14,marginBottom:6}}>Belum ada vendor yang dipilih</div>
              <div style={{fontSize:12}}>Pilih vendor di halaman Simulator, lalu tambah foto di Vendor List (tab Portofolio & Referensi)</div>
            </div>
          ):pickedKats.map(kat=>{
            const v=pickedVendor(kat);
            const briefAll=v.brief||[];
            const portAll=v.portfolio||[];
            const briefStar=briefAll.filter(p=>p.starred);
            const portStar=portAll.filter(p=>p.starred);
            const hasContent=briefStar.length>0||portStar.length>0;
            return(
              <div key={kat} style={{...cardS,marginBottom:16,padding:"16px 20px"}}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:hasContent?14:0}}>
                  <div>
                    <span style={{fontSize:14,fontWeight:600,color:C.pinkDark}}>{kat}</span>
                    <span style={{fontSize:12,color:C.textMuted,marginLeft:10}}>→ {v.nama}</span>
                  </div>
                  <div style={{display:"flex",gap:6,fontSize:11,color:C.textMuted}}>
                    {briefAll.length>0&&<span style={{background:"#fef3e2",color:"#a06820",padding:"2px 8px",borderRadius:10}}>🎯 {briefStar.length}/{briefAll.length} referensi</span>}
                    {portAll.length>0&&<span style={{background:C.lavLight,color:C.lav,padding:"2px 8px",borderRadius:10}}>📁 {portStar.length}/{portAll.length} portofolio</span>}
                    {!hasContent&&<span style={{color:C.textMuted,fontStyle:"italic"}}>Belum ada foto berbintang — edit vendor untuk menambah</span>}
                  </div>
                </div>
                {hasContent&&(
                  <div style={{display:"flex",gap:10,overflowX:"auto",paddingBottom:4}}>
                    {briefStar.map(p=>(
                      <div key={p.id} onClick={()=>setLightbox({...p,label:`🎯 Referensi · ${kat}`})} style={{flexShrink:0,width:140,height:105,borderRadius:8,overflow:"hidden",cursor:"zoom-in",border:`2px solid #e8a04566`,position:"relative"}}>
                        <img src={p.src} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>
                        <div style={{position:"absolute",top:4,left:4,background:"#fef3e2",color:"#a06820",fontSize:9,padding:"1px 6px",borderRadius:10,fontWeight:700}}>🎯 Ref</div>
                      </div>
                    ))}
                    {portStar.map(p=>(
                      <div key={p.id} onClick={()=>setLightbox({...p,label:`📁 Portofolio ${v.nama}`})} style={{flexShrink:0,width:140,height:105,borderRadius:8,overflow:"hidden",cursor:"zoom-in",border:`2px solid ${C.lav}44`,position:"relative"}}>
                        <img src={p.src} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>
                        <div style={{position:"absolute",top:4,left:4,background:C.lavLight,color:C.lav,fontSize:9,padding:"1px 6px",borderRadius:10,fontWeight:700}}>📁 Porto</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
          {pickedKats.length>0&&visiData.length===0&&(
            <div style={{...cardS,textAlign:"center",padding:"30px",color:C.textMuted,fontSize:12,marginTop:8}}>
              Ada {pickedKats.length} vendor dipilih, tapi belum ada foto berbintang. Buka Vendor List → Edit vendor → tab Portofolio/Referensi → bintangi foto terbaik.
            </div>
          )}
        </div>
      )}

      {/* ── MODE BANDINGKAN ───────────────────────────────────── */}
      {mode==="bandingkan"&&(
        <div>
          {/* Pilih kategori */}
          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:20}}>
            {katWithVendors.map(kat=>(
              <button key={kat} onClick={()=>setSelKat(kat)}
                style={{background:kat===selKatFinal?C.pinkLight:"transparent",border:`0.5px solid ${kat===selKatFinal?C.pink:C.border}`,borderRadius:20,padding:"5px 14px",fontSize:12,color:kat===selKatFinal?C.pinkDark:C.textMid,cursor:"pointer",fontWeight:kat===selKatFinal?600:400}}>
                {kat}
                {picks[kat]&&<span style={{marginLeft:5,fontSize:9,color:C.green}}>✓ dipilih</span>}
              </button>
            ))}
            {katWithVendors.length===0&&<div style={{fontSize:13,color:C.textMuted}}>Belum ada vendor aktif di list.</div>}
          </div>

          {/* Info jumlah vendor */}
          {selKatFinal&&vendorsInKat.length>0&&(
            <div style={{fontSize:11,color:C.textMuted,marginBottom:12}}>
              {vendorsInKat.length} vendor · {vendorsInKat.length>3?"geser ke kanan untuk lihat semua →":""}
            </div>
          )}

          {/* Kartu vendor — scroll horizontal, tiap kartu 300px */}
          {selKatFinal&&(
            vendorsInKat.length===0
            ? <div style={{...cardS,textAlign:"center",padding:"40px",color:C.textMuted,fontSize:13}}>Semua vendor di kategori ini berstatus Cancel.</div>
            : <div style={{display:"flex",gap:16,overflowX:"auto",paddingBottom:12,alignItems:"start"}}>
              {vendorsInKat.map(v=>{
                const isPicked=picks[selKatFinal]===v.id;
                const portAll=v.portfolio||[];
                const briefAll=v.brief||[];
                const st=STATUS_STYLE[v.status]||STATUS_STYLE["Belum Contact"];
                return(
                  <div key={v.id} style={{flexShrink:0,width:300,borderRadius:12,overflow:"hidden",border:`2px solid ${isPicked?C.amber:C.border}`,background:C.white}}>
                    {isPicked&&<div style={{background:"#fef3e2",color:"#a06820",fontSize:11,fontWeight:700,padding:"5px 14px",textAlign:"center",borderBottom:"0.5px solid #e8a04544"}}>⭐ Pilihan Kamu</div>}
                    <div style={{padding:"14px 16px",borderBottom:`0.5px solid ${C.border}`}}>
                      <div style={{fontSize:14,fontWeight:700,color:C.pinkDark,marginBottom:6}}>{v.nama}</div>
                      <div style={{display:"flex",gap:6,flexWrap:"wrap",alignItems:"center",marginBottom:6}}>
                        <Pill color={st.color} bg={st.bg}>{v.status}</Pill>
                        {v.rating>0&&<Stars value={v.rating}/>}
                      </div>
                      {v.harga>0&&(
                        <div style={{background:isPicked?"#fef3e2":C.pinkLight,borderRadius:8,padding:"8px 12px",marginBottom:6}}>
                          <div style={{fontSize:10,color:C.textMuted,marginBottom:2}}>Harga paket</div>
                          <div style={{fontSize:18,fontWeight:700,color:isPicked?"#a06820":C.pinkDark}}>Rp {fmtRp(v.harga)}</div>
                          {v.pax&&v.hargaPerPax>0&&<div style={{fontSize:10,color:C.textMuted,marginTop:1}}>{v.pax} pax · Rp {fmtRp(v.hargaPerPax)}/pax</div>}
                        </div>
                      )}
                      {(v.kelebihan||v.kekurangan)&&(
                        <div style={{display:"flex",flexDirection:"column",gap:6,marginTop:4}}>
                          {v.kelebihan&&(
                            <div style={{background:"#e8f8ee",borderRadius:8,padding:"8px 12px"}}>
                              <div style={{fontSize:10,fontWeight:700,color:C.green,marginBottom:4}}>✅ Kelebihan</div>
                              {v.kelebihan.split("\n").filter(Boolean).map((l,i)=>(
                                <div key={i} style={{fontSize:11,color:"#1f5c38",lineHeight:1.5}}>{l.startsWith("-")?l:`• ${l}`}</div>
                              ))}
                            </div>
                          )}
                          {v.kekurangan&&(
                            <div style={{background:"#fee8e8",borderRadius:8,padding:"8px 12px"}}>
                              <div style={{fontSize:10,fontWeight:700,color:"#a03030",marginBottom:4}}>❌ Kekurangan</div>
                              {v.kekurangan.split("\n").filter(Boolean).map((l,i)=>(
                                <div key={i} style={{fontSize:11,color:"#7a2020",lineHeight:1.5}}>{l.startsWith("-")?l:`• ${l}`}</div>
                              ))}
                            </div>
                          )}
                        </div>
                      )}
                      {v.catatan&&<div style={{fontSize:11,color:C.textMuted,marginTop:6,fontStyle:"italic"}}>{v.catatan}</div>}
                    </div>
                    {/* Portofolio vendor */}
                    {portAll.length>0&&(
                      <div style={{padding:"12px 14px",borderBottom:`0.5px solid ${C.border}`}}>
                        <div style={{fontSize:10,color:C.lav,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:8}}>📁 Portofolio</div>
                        <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:6}}>
                          {portAll.slice(0,4).map(p=>(
                            <div key={p.id} onClick={()=>setLightbox({...p,label:`📁 ${v.nama}`})} style={{aspectRatio:"4/3",borderRadius:7,overflow:"hidden",cursor:"zoom-in",position:"relative",border:`1.5px solid ${p.starred?C.lav:"transparent"}`}}>
                              <img src={p.src} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>
                              {p.starred&&<div style={{position:"absolute",top:3,right:3,background:C.lavLight,color:C.lav,fontSize:8,padding:"1px 5px",borderRadius:8,fontWeight:700}}>★</div>}
                            </div>
                          ))}
                        </div>
                        {portAll.length>4&&<div style={{fontSize:10,color:C.textMuted,marginTop:5}}>+{portAll.length-4} foto lainnya</div>}
                      </div>
                    )}
                    {/* Referensi untuk vendor ini */}
                    {briefAll.length>0&&(
                      <div style={{padding:"12px 14px"}}>
                        <div style={{fontSize:10,color:"#a06820",fontWeight:700,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:8}}>🎯 Referensi Kamu</div>
                        <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:6}}>
                          {briefAll.slice(0,4).map(p=>(
                            <div key={p.id} onClick={()=>setLightbox({...p,label:`🎯 Ref untuk ${v.nama}`})} style={{aspectRatio:"4/3",borderRadius:7,overflow:"hidden",cursor:"zoom-in",position:"relative",border:`1.5px solid ${p.starred?"#e8a045":"transparent"}`}}>
                              <img src={p.src} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>
                              {p.starred&&<div style={{position:"absolute",top:3,right:3,background:"#fef3e2",color:"#a06820",fontSize:8,padding:"1px 5px",borderRadius:8,fontWeight:700}}>★</div>}
                            </div>
                          ))}
                        </div>
                        {briefAll.length>4&&<div style={{fontSize:10,color:C.textMuted,marginTop:5}}>+{briefAll.length-4} foto lainnya</div>}
                      </div>
                    )}
                    {portAll.length===0&&briefAll.length===0&&(
                      <div style={{padding:"20px 14px",textAlign:"center",color:C.textMuted,fontSize:12}}>Belum ada foto. Edit vendor untuk tambah portofolio & referensi.</div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ─── NAV ──────────────────────────────────────────────────────
const NAV=[
  {key:"dashboard",label:"Dashboard",icon:"🏠"},
  {key:"checklist",label:"Checklist",icon:"✅"},
  {key:"vendors",label:"Vendor List",icon:"🏪"},
  {key:"simulator",label:"Simulator",icon:"🧮"},
  {key:"budget",label:"Budget",icon:"💰"},
  {key:"guests",label:"Guest List",icon:"👥"},
  {key:"timeline",label:"Timeline",icon:"🕐"},
  {key:"kalender",label:"Kalender",icon:"📅"},
  {key:"moodboard-dekor",label:"Moodboard Dekor",icon:"🌸"},
  {key:"moodboard-foto",label:"Moodboard Foto",icon:"📷"},
  {key:"playlist",label:"Playlist Musik",icon:"🎵"},
  {key:"visionboard",label:"Vision Board",icon:"🖼️"},
];

// ─── ROOT APP ─────────────────────────────────────────────────
export default function App() {
  const [page,setPage]=useState("dashboard");
  const [vendors,setVendors]=useState(()=>loadS("wp_vendors",[]));
  const [checklist,setChecklist]=useState(()=>loadS("wp_checklist",CHECKLIST_DEFAULT));
  const [guests,setGuests]=useState(()=>loadS("wp_guests",[]));
  const [budget,setBudget]=useState(()=>loadS("wp_budget",{total:0,payments:{}}));
  const [timeline,setTimeline]=useState(()=>loadS("wp_timeline",TIMELINE_DEFAULT));
  const [playlist,setPlaylist]=useState(()=>loadS("wp_playlist",[]));
  const [picks,setPicks]=useState(()=>loadS("wp_picks",{}));
  const [categoryOptions,setCategoryOptions]=useState(()=>mergeDefaultCategories(loadS("wp_categories",DEFAULT_CATEGORIES)));

  useEffect(()=>{localStorage.setItem("wp_vendors",JSON.stringify(vendors));},[vendors]);
  useEffect(()=>{localStorage.setItem("wp_checklist",JSON.stringify(checklist));},[checklist]);
  useEffect(()=>{localStorage.setItem("wp_guests",JSON.stringify(guests));},[guests]);
  useEffect(()=>{localStorage.setItem("wp_budget",JSON.stringify(budget));},[budget]);
  useEffect(()=>{localStorage.setItem("wp_timeline",JSON.stringify(timeline));},[timeline]);
  useEffect(()=>{localStorage.setItem("wp_playlist",JSON.stringify(playlist));},[playlist]);
  useEffect(()=>{localStorage.setItem("wp_picks",JSON.stringify(picks));},[picks]);
  useEffect(()=>{localStorage.setItem("wp_categories",JSON.stringify(categoryOptions));},[categoryOptions]);

  const exportAll=()=>{
    const blob=new Blob([JSON.stringify({vendors,checklist,guests,budget,timeline,playlist,picks,categoryOptions},null,2)],{type:"application/json"});
    // Note: visionboard images tidak diexport (terlalu besar, tersimpan terpisah)
    const a=document.createElement("a");a.href=URL.createObjectURL(blob);
    a.download=`tatiana-matheus-${new Date().toISOString().slice(0,10)}.json`;a.click();
  };
  const importAll=e=>{
    const file=e.target.files[0];if(!file)return;
    const r=new FileReader();
    r.onload=ev=>{
      try{
        const d=JSON.parse(ev.target.result);
        if(d.vendors)setVendors(d.vendors);
        if(d.checklist)setChecklist(d.checklist);
        if(d.guests)setGuests(d.guests);
        if(d.budget)setBudget(d.budget);
        if(d.timeline)setTimeline(d.timeline);
        if(d.playlist)setPlaylist(d.playlist);
        if(d.picks)setPicks(d.picks);
        if(d.categoryOptions)setCategoryOptions(mergeDefaultCategories(d.categoryOptions));
        alert("Data berhasil diimport! 🎉");
      }catch{alert("Gagal membaca file.");}
    };
    r.readAsText(file);e.target.value="";
  };

  const days=daysUntil(WEDDING_DATE);
  const cur=NAV.find(n=>n.key===page);

  return(
    <div style={{display:"flex",minHeight:"100vh",background:C.bg,fontFamily:"'Inter',system-ui,sans-serif",fontSize:14}}>
      {/* Sidebar */}
      <div style={{width:210,background:C.white,borderRight:`0.5px solid ${C.border}`,display:"flex",flexDirection:"column",flexShrink:0,position:"sticky",top:0,height:"100vh",overflowY:"auto"}}>
        <div style={{padding:"20px 18px 16px",borderBottom:`0.5px solid ${C.border}`,flexShrink:0}}>
          <div style={{fontSize:15,fontWeight:700,color:C.pinkDark}}>💍 {COUPLE.bride} & {COUPLE.groom}</div>
          <div style={{fontSize:11,color:C.textMuted,marginTop:3}}>17 Juli 2027</div>
          <div style={{marginTop:8,background:C.pinkLight,borderRadius:8,padding:"6px 10px"}}>
            <span style={{fontSize:20,fontWeight:800,color:C.pink}}>{days}</span>
            <span style={{fontSize:11,color:C.textMuted,marginLeft:4}}>hari lagi</span>
          </div>
        </div>
        <nav style={{flex:1,padding:"8px 0"}}>
          {NAV.map(n=>(
            <button key={n.key} onClick={()=>setPage(n.key)} style={{display:"flex",alignItems:"center",gap:10,width:"100%",padding:"8px 18px",background:page===n.key?C.pinkLight:"transparent",borderRight:page===n.key?`2px solid ${C.pink}`:"2px solid transparent",border:"none",cursor:"pointer",fontSize:13,color:page===n.key?C.pinkDark:C.textMid,fontWeight:page===n.key?600:400,textAlign:"left",fontFamily:"inherit"}}>
              <span style={{fontSize:14}}>{n.icon}</span>{n.label}
            </button>
          ))}
        </nav>
        <div style={{padding:"12px 14px",borderTop:`0.5px solid ${C.border}`,display:"flex",flexDirection:"column",gap:7,flexShrink:0}}>
          <button onClick={exportAll} style={{...btnO,width:"100%",fontSize:12,padding:"7px 12px"}}>↓ Export JSON</button>
          <label style={{...btnO,width:"100%",fontSize:12,padding:"7px 12px",cursor:"pointer",textAlign:"center",boxSizing:"border-box"}}>
            ↑ Import JSON<input type="file" accept=".json" onChange={importAll} style={{display:"none"}}/>
          </label>
        </div>
      </div>

      {/* Main */}
      <div style={{flex:1,display:"flex",flexDirection:"column",minWidth:0}}>
        <div style={{background:C.white,borderBottom:`0.5px solid ${C.border}`,padding:"14px 28px",display:"flex",alignItems:"center",gap:12,position:"sticky",top:0,zIndex:10}}>
          <span style={{fontSize:18}}>{cur?.icon}</span>
          <span style={{fontSize:16,fontWeight:600,color:C.pinkDark}}>{cur?.label}</span>
        </div>
        <div style={{flex:1,padding:"28px",maxWidth:980,width:"100%",margin:"0 auto",boxSizing:"border-box"}}>
          {page==="dashboard"&&<Dashboard vendors={vendors} checklist={checklist} guests={guests} budget={budget} timeline={timeline}/>}
          {page==="checklist"&&<ChecklistPage checklist={checklist} setChecklist={setChecklist}/>}
          {page==="vendors"&&<VendorListPage vendors={vendors} setVendors={setVendors} categoryOptions={categoryOptions} setCategoryOptions={setCategoryOptions}/>}
          {page==="simulator"&&<SimulatorPage vendors={vendors} budget={budget} picks={picks} setPicks={setPicks} categoryOptions={categoryOptions}/>}
          {page==="budget"&&<BudgetPage budget={budget} setBudget={setBudget} vendors={vendors} picks={picks}/>}
          {page==="guests"&&<GuestListPage guests={guests} setGuests={setGuests}/>}
          {page==="timeline"&&<TimelinePage timeline={timeline} setTimeline={setTimeline}/>}
          {page==="kalender"&&<KalenderPage checklist={checklist} vendors={vendors}/>}
          {page==="moodboard-dekor"&&<MoodboardPage title="Moodboard Dekorasi" storageKey="wp_mb_dekor" accentColor={C.pink} icon="🌸"/>}
          {page==="moodboard-foto"&&<MoodboardPage title="Moodboard Photography" storageKey="wp_mb_foto" accentColor={C.lav} icon="📷"/>}
          {page==="playlist"&&<PlaylistPage playlist={playlist} setPlaylist={setPlaylist}/>}
          {page==="visionboard"&&<VisionBoardPage vendors={vendors} picks={picks} categoryOptions={categoryOptions}/>}
        </div>
      </div>
    </div>
  );
}
